import React, { useState, useEffect } from 'react';
import {
  Box,
  Paper,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  IconButton,
  Typography,
  Checkbox,
  FormControlLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  InputAdornment,
  Stack,
  useMediaQuery,
  useTheme,
  CircularProgress,
  Chip,
  Fade,
  Skeleton,
  Divider,
  Alert,
  TablePagination,
  Tooltip,
  Avatar ,
  Grid,
  Autocomplete,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormHelperText
} from '@mui/material';

import {
  Edit as EditIcon,
  Search as SearchIcon,
  Close as CloseIcon,
  Description as DescriptionIcon,
  Person as PersonIcon,
  LocalHospital as HospitalIcon,
  Assignment as AssignmentIcon,
  Medication as MedicationIcon,
  Science as ScienceIcon,
  Assessment as AssessmentIcon,
  ChevronLeft,
  ChevronRight,
  FirstPage,
  LastPage,
  FilterList as FilterListIcon,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon ,
   Delete as DeleteIcon ,
   Send  ,Edit  , Delete 
} from '@mui/icons-material';

import { Snackbar } from '@mui/material';
import { 
  insurancetypes, 
  claimmonths, 
  claimdatesbymonth, 
  claimServices, 
  claimDiagnosis, 
  claimprocedures, 
  claimmedications, 
  claimpatients, 
  updatePatientCInfo,
  loadInsuredServicesdb,
  servicesTodaycl,
  saveServiceProvidedCalim,
  loadDiagnosisOptionsdb,
  loadProcedureOptionsdb,
  saveOrUpdateDiagnosisDocumetingClami ,
  saveOrUpdateProcedureDocumetingClami ,
    loadPatientDiagnosisclam , loadLabdb ,
  loadPatientLabsclim ,saveOrUpdateLabsClami
   ,loadPatientScansclam ,saveOrUpdateScansClami
    , loadAvailableScanscilm,
  loadRequestedMedsInpatient ,loadMedicationsCalim,
  loadMedicationByAge ,
  addMedicationdb , loadRequestedMedsdb ,updateMedicationdb ,
  deleteMedicationclam
} from '../BaseURL';
import Swal from 'sweetalert2'; 
import axios from 'axios';
import { frequencyMap ,frequencyMultiplier, ErrorMessage ,standardFrequencies ,MEDICATION_ROUTES, successMessage} from '../Message';

const HospitalClaims = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  // ✅ ADD CURRENT USER STATE
  const [currentUser, setCurrentUser] = useState('');

  // State for data
  const [insuranceTypes, setInsuranceTypes] = useState([]);
  const [insuranceType, setInsuranceType] = useState('');

  const [claimMonths, setClaimMonths] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState('');

  const [claimDates, setClaimDates] = useState([]);
  const [selectedDate, setSelectedDate] = useState('');

  const [servicesProvidedList, setServicesProvidedList] = useState([]);
  const [selectedService, setSelectedService] = useState('');

  const [diagnosisList, setDiagnosisList] = useState([]);
  const [selectedDiagnosis, setSelectedDiagnosis] = useState('');

  const [procedureList, setProcedureList] = useState([]);
  const [selectedProcedure, setSelectedProcedure] = useState('');

  const [medicationList, setMedicationList] = useState([]);
  const [selectedMedication, setSelectedMedication] = useState('');

  // ✅ ADD NEW STATES FOR SERVICE PROVIDED AND ATTENDANCE TYPE
  const [insuredServices, setInsuredServices] = useState([]);
  const [serviceProvided, setServiceProvided] = useState('');
  const [attendanceType, setAttendanceType] = useState('');

  // Loading states
  const [loadingInsurance, setLoadingInsurance] = useState(false);
  const [loadingMonths, setLoadingMonths] = useState(false);
  const [loadingDates, setLoadingDates] = useState(false);
  const [loadingServices, setLoadingServices] = useState(false);
  const [loadingDiagnosis, setLoadingDiagnosis] = useState(false);
  const [loadingProcedures, setLoadingProcedures] = useState(false);
  const [loadingMedications, setLoadingMedications] = useState(false);
  const [loading, setLoading] = useState(false); // ✅ ADD GENERAL LOADING STATE

    // Add these states (around line 100 after other state declarations)
  const [selectedDiagnoses, setSelectedDiagnoses] = useState([]);
  const [selectedProcedures, setSelectedProcedures] = useState([]);
  const [diagnosisOptions, setDiagnosisOptions] = useState([]);
  const [procedureOptions, setprocedureOptions] = useState([]);

  // Error states
  const [errorInsurance, setErrorInsurance] = useState(null);
  const [errorMonths, setErrorMonths] = useState(null);
  const [errorDates, setErrorDates] = useState(null);
  const [errorServices, setErrorServices] = useState(null);
  const [errorDiagnosis, setErrorDiagnosis] = useState(null);
  const [errorProcedures, setErrorProcedures] = useState(null);
  const [errorMedications, setErrorMedications] = useState(null);
 
  const [patients, setPatients] = useState([]);
  const [loadingPatients, setLoadingPatients] = useState(false);
  const [errorPatients, setErrorPatients] = useState(null);

  const [searchTerm, setSearchTerm] = useState('');
  
  // Pagination states
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
  const [patientStateFilter, setPatientStateFilter] = useState('All');
  const [editingField, setEditingField] = useState(null);
  const [editValue, setEditValue] = useState('');
  const [showDobPicker, setShowDobPicker] = useState(false);

  const [selectedPatientId, setSelectedPatientId] = useState(null);
  // Composite key so two visits of the same patient (same patient_id, different
  // dat / d_dat) are treated as two distinct rows. Selecting one no longer
  // silently switches to the other.
  const [selectedVisitKey, setSelectedVisitKey] = useState(null);
  const visitKeyOf = (p) => p ? `${p.patient_id}||${p.dat || ''}||${p.d_dat || ''}` : null;
  const [selectedPatientData, setSelectedPatientData] = useState(null); // ✅ ADD THIS
  const [isDependant, setIsDependant] = useState(false);

  // Add these new loading states at the top with other state declarations
const [loadingDiagnosisOptions, setLoadingDiagnosisOptions] = useState(false);
const [loadingProcedureOptions, setLoadingProcedureOptions] = useState(false);


const [selectedLabs, setSelectedLabs] = useState([]);
const [labOptions, setLabOptions] = useState([]);
const [loadingLabOptions, setLoadingLabOptions] = useState(false);


const [selectedScans, setSelectedScans] = useState([]);
const [scanOptions, setScanOptions] = useState([]);
const [loadingScanOptions, setLoadingScanOptions] = useState(false);

// ✅ Medication List States
const [requestedMeds, setRequestedMeds] = useState([]);
const [loadingMeds, setLoadingMeds] = useState(false);
const [medDialogOpen, setMedDialogOpen] = useState(false);


const [medications, setMedications] = useState([]);
const [medSearchTerm, setMedSearchTerm] = useState("");
const [medPage, setMedPage] = useState(0);
const [medRowsPerPage, setMedRowsPerPage] = useState(10);

const [selectedMed, setSelectedMed] = useState(null);

// request form
const [doseAmount, setDoseAmount] = useState("");
const [doseUnit, setDoseUnit] = useState("");
const [frequency, setFrequency] = useState("");
const [days, setDays] = useState(1);
const [route, setRoute] = useState("");
const [qty, setQty] = useState(0);
const [autoCalculate, setAutoCalculate] = useState(false);

// requested meds

const [editingIndex, setEditingIndex] = useState(null);
const [reqMedPage, setReqMedPage] = useState(0);
const [reqMedRowsPerPage, setReqMedRowsPerPage] = useState(10);

const [loadingAvailableMeds, setLoadingAvailableMeds] = useState(false);
const [chronicMeds, setChronicMeds] = useState([]);
const [selectedPatient, setSelectedPatient] = useState(null);
const [doseAmountError, setDoseAmountError] = useState(false);
const [frequencyError, setFrequencyError] = useState(false);
const [daysError, setDaysError] = useState(false);
const [routeError, setRouteError] = useState(false);
const [qtyError, setQtyError] = useState(false);

const [medicationDate, setMedicationDate] = useState("");
const [medicationDateError, setMedicationDateError] = useState(false);
const [dose, setDose] = useState("");

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  // ✅ ADD CHECKBOX STATES
const [serviceTypeChecks, setServiceTypeChecks] = useState({
  outPatient: false,
  inPatient: false,
  pharmacy: false,
  diagnostic: false,
  allInclusive: true // Always checked by default
});
  
  const [claimsData, setClaimsData] = useState({
    surname: '',
    otherNames: '',
    patientId: '',
    gender: 'Select >>',
    firstVisit: '',
    age: '',
    membershipNo: '',
    addressId: '',
    ccc: '',
    secondVisit: '',
    nhisNo: '',
    patientState: '',
    servicesProvided: '',
    servicesOutcome: 'Services Outcome >>',
    serviceNote: '',
    physicianName: '',
    services: '',
    physicianCode: '',
    gDrgCode: '',
    tariff: '',
    attendanceType: 'Attendance>>',
    mainServiceDescription: 'Description >>',
    specialtyGDRG: '',        
    specialtyDescription: '', 
    specialtyCode: ''          
  });

  
  // ✅ ADD LOAD CURRENT USER ON MOUNT
  useEffect(() => {
    const savedUserInfo = localStorage.getItem('userInfo');
    if (savedUserInfo) {
      const userInfo = JSON.parse(savedUserInfo);
      const userName = userInfo.name || ''; 
      setCurrentUser(userName);
    }
  }, []);

 
useEffect(() => {
  if (!selectedVisitKey) return;

  if (diagnosisOptions.length > 0 && procedureOptions.length > 0 && labOptions.length > 0) {
    // Look up by the composite visit key so two visits of the same patient
    // resolve to the correct row. Falling back to patient_id alone here was
    // the bug that made selecting a second visit re-load the first visit.
    const patient = patients.find(p => visitKeyOf(p) === selectedVisitKey);
    if (patient) {
      loadPatientDiagnosis(patient.patient_id, patient.d_dat, patient.dat);
      loadPatientLabs(patient.patient_id, patient.d_dat, patient.dat);
      loadPatientScans(patient.patient_id, patient.d_dat, patient.dat);
    }
  }
}, [selectedVisitKey, diagnosisOptions, procedureOptions ]);

  // ✅ ADD FUNCTION TO LOAD INSURED SERVICES
  const loadInsuredServices = async (insuranceName, patientAge) => {
    setLoading(true);
    try {
      const response = await fetch(`${loadInsuredServicesdb}?STATUS=${insuranceName}&charge_status=Main Services&patientAge=${patientAge}`);
      
      if (!response.ok) throw new Error(`Failed to fetch: ${response.status}`);
      
      const data = await response.json();
      
      if (data.success) {
        setInsuredServices(data.results);
        console.log("Loaded insured services:", data.results);
      } else {
        setInsuredServices([]);
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: error.message || "Failed to load insured services",
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  // ✅ ADD FUNCTION TO LOAD SERVICE AND ATTENDANCE
const loadServiceAndAttendance = async (patientId, dat) => {
  setLoading(true);
  try {
    const response = await fetch(`${servicesTodaycl}?patient_id=${patientId}&dat=${dat}`);
    
    if (!response.ok) throw new Error(`Failed to fetch: ${response.status}`);
    
    const data = await response.json();

    if (data.success && data.data) {
      const { name, att, which_code, ph_name, ph_code, documenting, procedure_ } = data.data;
      
      setServiceProvided(name || '');
      setAttendanceType(att || '');
      
      // ✅ UPDATE CLAIMS DATA WITH ALL FIELDS
      setClaimsData(prev => ({
        ...prev,
        servicesProvided: name || '',
        attendanceType: att || '',
        specialtyGDRG: which_code || '',
        specialtyDescription: name || '',
        specialtyCode: which_code ? which_code.substring(0, 4) : '',
        physicianName: ph_name || '',
        physicianCode: ph_code || ''
      }));

      // ✅ LOAD AND SET DIAGNOSES
      if (documenting && documenting.trim() !== "") {
        const diagnosisNames = documenting
          .split(",")
          .map((item) => item.trim())
          .filter(name => name.length > 0);

        // Wait a bit to ensure diagnosisOptions is loaded
        setTimeout(() => {
          const matchedDiagnoses = diagnosisOptions.filter((opt) =>
            diagnosisNames.some(
              (parsedName) => opt.name.toLowerCase() === parsedName.toLowerCase()
            )
          );
          setSelectedDiagnoses(matchedDiagnoses);
        }, 100);
      } else {
        setSelectedDiagnoses([]);
      }

      // ✅ LOAD AND SET PROCEDURES
      if (procedure_ && procedure_.trim() !== "") {
        const procedureNames = procedure_
          .split(",")
          .map((p) => p.trim())
          .filter(name => name.length > 0);

        // Wait a bit to ensure procedureOptions is loaded
        setTimeout(() => {
          const matchedProcedures = procedureOptions.filter((opt) =>
            procedureNames.some(
              (parsedName) => opt.name.toLowerCase() === parsedName.toLowerCase()
            )
          );
          setSelectedProcedures(matchedProcedures);
        }, 100);
      } else {
        setSelectedProcedures([]);
      }
    } else {
      setServiceProvided('');
      setAttendanceType('');
      setSelectedDiagnoses([]);
      setSelectedProcedures([]);
      
      // Clear specialty and physician fields
      setClaimsData(prev => ({
        ...prev,
        servicesProvided: '',
        attendanceType: '',
        specialtyGDRG: '',
        specialtyDescription: '',
        specialtyCode: '',
        physicianName: '',
        physicianCode: ''
      }));
    }
  } catch (error) {
    console.error('Error loading service and attendance:', error);
  } finally {
    setLoading(false);
  }
};

 
const saveServiceProvided = async (
  updateConfirmed = false,
  customType = null,
  customService = null,
  selectedPatient = null
) => {
  if (!selectedPatient) return false;

  const finalAttendanceType = customType || attendanceType;
  const finalServiceProvided = customService || serviceProvided;

  const selectedService = insuredServices.find(
    (s) => s.name === finalServiceProvided
  );

  setLoading(true);
  try {
    const response = await fetch(saveServiceProvidedCalim, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        patient_id: selectedPatient.patient_id,
        dat: selectedPatient.d_dat,
        service_name: finalServiceProvided,
        attendance_type: finalAttendanceType,
        insurance: insuranceType,
        code: selectedService?.code || "",
        toup: selectedService?.toup || 0,
        amo: selectedService?.amo || 0,
        unin: selectedService?.unin || 0,
        currentUser,
        patientName: selectedPatient.patient_name,
        updateConfirmed,
      })
    });

    const data = await response.json();

    if (data.success) {
      return true; // ✅ RETURN SUCCESS
    }
    return false;
  } catch (error) {
    console.error("Error saving service:", error);
    Swal.fire("Error", "Unable to save service information.", "error");
    return false;
  } finally {
    setLoading(false);
  }
};

  // Fetch Insurance Types
  useEffect(() => {
    const fetchInsuranceTypes = async () => {
      setLoadingInsurance(true);
      setErrorInsurance(null);
      
      try {
        const res = await fetch(insurancetypes);
        if (!res.ok) throw new Error(`Failed to fetch: ${res.status}`);
        const data = await res.json();
        setInsuranceTypes(data);
      } catch (err) {
        console.error('Failed to load insurance types:', err);
        setErrorInsurance(err.message);
      } finally {
        setLoadingInsurance(false);
      }
    };

    fetchInsuranceTypes();
  }, []);

  // Fetch Claim Months
  useEffect(() => {
    const fetchClaimMonths = async () => {
      setLoadingMonths(true);
      setErrorMonths(null);
      
      try {
        const res = await fetch(claimmonths);
        if (!res.ok) throw new Error(`Failed to fetch: ${res.status}`);
        const data = await res.json();
        setClaimMonths(data);
      } catch (err) {
        console.error('Failed to load claim months:', err);
        setErrorMonths(err.message);
      } finally {
        setLoadingMonths(false);
      }
    };

    fetchClaimMonths();
  }, []);

  // Fetch Claim Dates by Month
  useEffect(() => {
    if (!selectedMonth) {
      setClaimDates([]);
      setSelectedDate('');
      return;
    }

    const fetchDates = async () => {
      setLoadingDates(true);
      setErrorDates(null);
      
      try {
        const res = await fetch(`${claimdatesbymonth}?month=${selectedMonth}&insurance=${encodeURIComponent(insuranceType)}`);
        if (!res.ok) throw new Error(`Failed to fetch: ${res.status}`);
        const data = await res.json();
        setClaimDates(data);
      } catch (err) {
        console.error('Failed to load claim dates:', err);
        setErrorDates(err.message);
      } finally {
        setLoadingDates(false);
      }
    };

    fetchDates();
  }, [selectedMonth, insuranceType]);

  // Fetch Services
  useEffect(() => {
    if (!insuranceType || !selectedMonth) {
      setServicesProvidedList([]);
      setSelectedService('');
      return;
    }

    const fetchServices = async () => {
      setLoadingServices(true);
      setErrorServices(null);
      
      try {
        const url = `${claimServices}?insurance=${encodeURIComponent(insuranceType)}&month=${selectedMonth}`;
        const res = await fetch(url);
        if (!res.ok) throw new Error(`Failed to fetch: ${res.status}`);
        const data = await res.json();
        setServicesProvidedList(data);
      } catch (err) {
        console.error('Failed to load services:', err);
        setErrorServices(err.message);
      } finally {
        setLoadingServices(false);
      }
    };

    fetchServices();
  }, [insuranceType, selectedMonth]);

  // Fetch Diagnosis
  useEffect(() => {
    if (!insuranceType || !selectedMonth) {
      setDiagnosisList([]);
      setSelectedDiagnosis('');
      return;
    }

    const fetchDiagnosis = async () => {
      setLoadingDiagnosis(true);
      setErrorDiagnosis(null);
      
      try {
        const url = `${claimDiagnosis}?insurance=${encodeURIComponent(insuranceType)}&month=${selectedMonth}`;
        const res = await fetch(url);
        if (!res.ok) throw new Error(`Failed to fetch: ${res.status}`);
        const data = await res.json();
        setDiagnosisList(data);
      } catch (err) {
        console.error('Failed to load diagnosis:', err);
        setErrorDiagnosis(err.message);
      } finally {
        setLoadingDiagnosis(false);
      }
    };

    fetchDiagnosis();
  }, [insuranceType, selectedMonth]);

  // Fetch Procedures
  useEffect(() => {
    if (!insuranceType || !selectedMonth) {
      setProcedureList([]);
      setSelectedProcedure('');
      return;
    }

    const fetchProcedures = async () => {
      setLoadingProcedures(true);
      setErrorProcedures(null);
      
      try {
        const url = `${claimprocedures}?insurance=${encodeURIComponent(insuranceType)}&month=${selectedMonth}`;
        const res = await fetch(url);
        if (!res.ok) throw new Error(`Failed to fetch: ${res.status}`);
        const data = await res.json();
        setProcedureList(data);
      } catch (err) {
        console.error('Failed to load procedures:', err);
        setErrorProcedures(err.message);
      } finally {
        setLoadingProcedures(false);
      }
    };

    fetchProcedures();
  }, [insuranceType, selectedMonth]);

  // Fetch Medications
  useEffect(() => {
    if (!insuranceType || !selectedMonth) {
      setMedicationList([]);
      setSelectedMedication('');
      return;
    }

    const fetchMedications = async () => {
      setLoadingMedications(true);
      setErrorMedications(null);
      
      try {
        const url = `${claimmedications}?insurance=${encodeURIComponent(insuranceType)}&month=${selectedMonth}`;
        const res = await fetch(url);
        if (!res.ok) throw new Error(`Failed to fetch: ${res.status}`);
        const data = await res.json();
        setMedicationList(data);
      } catch (err) {
        console.error('Failed to load medications:', err);
        setErrorMedications(err.message);
      } finally {
        setLoadingMedications(false);
      }
    };

    fetchMedications();
  }, [insuranceType, selectedMonth]);


  useEffect(() => {
    if (!insuranceType || !selectedMonth) {
      setPatients([]);
      setErrorPatients(null);
      return;
    }

    const fetchPatients = async () => {
      setLoadingPatients(true);
      setErrorPatients(null);

      try {
        let url = `${claimpatients}?insurance=${encodeURIComponent(insuranceType)}&month=${selectedMonth}`;

        if (selectedDate) {
          url += `&date=${selectedDate}`;
        }

        if (patientStateFilter !== 'All') {
          url += `&patientState=${patientStateFilter}`;
        }

        // ✅ ADD ADVANCED FILTERS
        if (selectedService) {
          url += `&service=${encodeURIComponent(selectedService)}`;
        }
        if (selectedDiagnosis) {
          url += `&diagnosis=${encodeURIComponent(selectedDiagnosis)}`;
        }
        if (selectedProcedure) {
          url += `&procedure=${encodeURIComponent(selectedProcedure)}`;
        }
        if (selectedMedication) {
          url += `&medication=${encodeURIComponent(selectedMedication)}`;
        }

        const res = await fetch(url);
        if (!res.ok) throw new Error(`Failed to fetch patients: ${res.status}`);
        const data = await res.json();
        setPatients(data);
        setPage(0);
      } catch (err) {
        console.error('Failed to load patients', err);
        setErrorPatients(err.message);
        setPatients([]);
      } finally {
        setLoadingPatients(false);
      }
    };

    fetchPatients();
  }, [
    insuranceType,
    selectedMonth,
    selectedDate,
    patientStateFilter,
    selectedService,      // ✅ ADD
    selectedDiagnosis,    // ✅ ADD
    selectedProcedure,    // ✅ ADD
    selectedMedication    // ✅ ADD
  ]);

  useEffect(() => {
  if (medDialogOpen) {
    loadAvailableMedications();
  }
}, [medDialogOpen, insuranceType]);

// Helper function
const normalizeFrequency = (freq) => {
  if (!freq) return "";
  return frequencyMap[freq.toLowerCase().trim()] || freq;
};



const FRACTION_MAP = { "¼": 0.25, "½": 0.5, "¾": 0.75 };
const normalizeUnicodeFractions = (s) =>
  String(s || "").replace(/[¼½¾]/g, (m) => String(FRACTION_MAP[m] ?? m));


const parseDoseNumber = (doseStr) => {
  if (!doseStr) return 0;
  const cleaned = normalizeUnicodeFractions(doseStr).trim().toLowerCase();
  // match number (int/decimal or fraction) at the start
  const m = cleaned.match(/^(\d+(?:\.\d+)?|\d+\/\d+)/);
  if (!m) return 0;
  if (m[1].includes("/")) {
    const [a, b] = m[1].split("/").map(Number);
    return b ? a / b : Number(m[1]) || 0;
  }
  return parseFloat(m[1]) || 0;
};

const computeQty = ({
  doseAmount,
  doseString,
  days,
  frequency,
  doseUnit,
  normalizeFrequencyFn,
  freqMultiplierMap
}) => {
  const normalized = normalizeFrequencyFn(frequency || "");
  const perDay = freqMultiplierMap[normalized] ?? 1;

  const amount =
    typeof doseAmount === "number" && !isNaN(doseAmount)
      ? doseAmount
      : parseDoseNumber(doseString);

  if (!amount || !Number(days)) return 0;

  // ✅ Same formula for liquids and solids
  // Quantity = dose × frequency per day × number of days
  return Math.ceil(Number(amount) * Number(perDay) * Number(days));
};


useEffect(() => {
  if (!autoCalculate) return; // if OFF, skip auto calculation

  // Convert doseAmount to number (it's stored as string from TextField)
  const numericDoseAmount = parseFloat(doseAmount) || 0;

  const nextQty = computeQty({
    doseAmount: numericDoseAmount,
    doseString: dose,
    days,
    frequency,
    doseUnit,
    normalizeFrequencyFn: normalizeFrequency,
    freqMultiplierMap: frequencyMultiplier,
  });
  setQty(nextQty);
}, [doseAmount, dose, days, frequency, doseUnit, autoCalculate]);


  const handleInputChange = (field, value) => {
    setClaimsData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const filteredPatients = Array.isArray(patients)
    ? patients.filter(patient =>
        (patient.patient_name || '')
          .toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        (patient.patient_id || '')
          .toLowerCase()
          .includes(searchTerm.toLowerCase())
      )
    : [];

  const paginatedPatients = filteredPatients.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  // Slim section header — uppercase eyebrow + step number + title.
  // Redesigned Nov 2026 from a heavy gradient badge + gradient border-image
  // to a flat design that matches the doctor's Outpatient Workspace.
  const SectionHeader = ({ number, title, icon: Icon }) => (
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 1.25,
      mb: 2,
      pb: 1.25,
      borderBottom: '1px solid #eef2f6',
    }}>
      <Box
        sx={{
          width: 26,
          height: 26,
          borderRadius: 1,
          bgcolor: '#1A9B7F',
          color: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 800,
          fontSize: '0.82rem',
          flexShrink: 0,
        }}
      >
        {number}
      </Box>
      {Icon && <Icon sx={{ color: '#1A9B7F', fontSize: 20 }} />}
      <Typography sx={{
        fontSize: '0.98rem',
        fontWeight: 700,
        color: '#0f172a',
        letterSpacing: '-0.15px',
      }}>
        {title}
      </Typography>
    </Box>
  );

  const autoCalcUnits = [
  "tab", "tablet",
  "cap", "capsule",
  "pill", "lozenge", "suppository",
  "amp", "vial"
];

  const isAutoCalcUnit = (unit = "") => {
  return autoCalcUnits.some(u => unit.toLowerCase().includes(u));
};

  const solidKeywords = ["tablet", "tab", "capsule", "cap", "pill", "lozenge", "suppository"];
const isSolidByName = (name = "") => {
  return solidKeywords.some(k => name.toLowerCase().includes(k));
};

  const TablePaginationActions = (props) => {
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };


  



    return (
      <Box sx={{ flexShrink: 0, display: 'flex', gap: 0.5 }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          size="small"
          sx={{
            bgcolor: page === 0 ? 'transparent' : 'rgba(26, 155, 127, 0.08)',
            '&:hover': { bgcolor: 'rgba(26, 155, 127, 0.15)' }
          }}
        >
          <FirstPage fontSize="small" />
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          size="small"
          sx={{
            bgcolor: page === 0 ? 'transparent' : 'rgba(26, 155, 127, 0.08)',
            '&:hover': { bgcolor: 'rgba(26, 155, 127, 0.15)' }
          }}
        >
          <ChevronLeft fontSize="small" />
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          size="small"
          sx={{
            bgcolor: page >= Math.ceil(count / rowsPerPage) - 1 ? 'transparent' : 'rgba(26, 155, 127, 0.08)',
            '&:hover': { bgcolor: 'rgba(26, 155, 127, 0.15)' }
          }}
        >
          <ChevronRight fontSize="small" />
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          size="small"
          sx={{
            bgcolor: page >= Math.ceil(count / rowsPerPage) - 1 ? 'transparent' : 'rgba(26, 155, 127, 0.08)',
            '&:hover': { bgcolor: 'rgba(26, 155, 127, 0.15)' }
          }}
        >
          <LastPage fontSize="small" />
        </IconButton>
      </Box>
    );
  };

  const calculateAge = (dob) => {
    if (!dob) return '';
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  const calculateDaysBetween = (date1, date2) => {
    if (!date1 || !date2) return 0;
    const d1 = new Date(date1);
    const d2 = new Date(date2);
    const diffTime = Math.abs(d2 - d1);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

 

const handlePatientSelect = (patient) => {
  setSelectedPatientId(patient.patient_id);
  setSelectedVisitKey(visitKeyOf(patient));
  setSelectedPatientData(patient);

  setIsDependant(patient.Dependant === 1);

  const age = calculateAge(patient.dob);
  const patientState = patient.dat === patient.d_dat ? 'Outpatient' : 'Inpatient';
  const daysBetween = calculateDaysBetween(patient.dat, patient.d_dat);

  // Set checkboxes
  setServiceTypeChecks({
    outPatient: patientState === 'Outpatient',
    inPatient: patientState === 'Inpatient',
    pharmacy: false,
    diagnostic: false,
    allInclusive: true
  });

  setClaimsData({
    surname: patient.surname || '',
    otherNames: patient.othername || '',
    patientId: patient.patient_id || '',
    gender: patient.gender || 'Select >>',
    firstVisit: patient.dat || '',
    age: age.toString(),
    membershipNo: patient.member_no || '',
    addressId: '',
    ccc: patient.ccc || '',
    secondVisit: patient.d_dat || '',
    nhisNo: daysBetween.toString(),
    patientState: patientState,
    servicesProvided: '',
    servicesOutcome: 'Services Outcome >>',
    serviceNote: '',
    physicianName: '',
    services: '',
    physicianCode: '',
    gDrgCode: '',
    tariff: '',
    attendanceType: 'Attendance>>',
    mainServiceDescription: 'Description >>',
    specialtyGDRG: '',
    specialtyDescription: '',
    specialtyCode: ''
  });

  // ✅ Load everything needed — in PARALLEL. Each of these loaders is an
  // independent async fetch with no dependency on the others, so firing
  // them sequentially turned what should be ~200ms of wall time into ~1.4s
  // (the user-visible patient-select lag). Promise.all collapses them
  // into a single round-trip window. We catch with .catch so one failing
  // loader doesn't reject the whole batch and prevent the rest from
  // populating the panel — each loader already swallows its own errors
  // internally; this is just a final safety net.
  Promise.all([
    loadInsuredServices(insuranceType, age),
    loadServiceAndAttendance(patient.patient_id, patient.d_dat),
    loadDiagnosisOptions(age, patient.gender, insuranceType),
    loadProcedureOptions(age, patient.gender, insuranceType),
    loadLabOptions(insuranceType),
    loadScanOptions(insuranceType),
    loadRequestedMedications(patient.patient_id, patient.dat, patient.d_dat),
  ]).catch((err) => console.error('[Claims] patient-select parallel load error:', err));
};

 
const handleUpdateField = async (field, value) => {
    if (!selectedPatientId) return;

    setLoading(true); // ✅ START LOADING
    try {
      const response = await fetch(`${updatePatientCInfo}/${selectedPatientId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          field, 
          value,
          dat: claimsData.firstVisit
        }),
      });

      const data = await response.json();

      if (data.success) {
        // ✅ ONLY UPDATE THE PATIENTS LIST, DON'T RELOAD EVERYTHING
        const fetchUrl = `${claimpatients}?insurance=${encodeURIComponent(
          insuranceType
        )}&month=${selectedMonth}${selectedDate ? `&date=${selectedDate}` : ''}${
          patientStateFilter !== 'All' ? `&patientState=${patientStateFilter}` : ''
        }`;
        
        const res = await fetch(fetchUrl);
        const updatedPatients = await res.json();
        setPatients(updatedPatients);

        const updatedPatient = updatedPatients.find(p => p.patient_id === selectedPatientId);
        
        // ✅ UPDATE ONLY THE RELEVANT CLAIMS DATA FIELDS WITHOUT TRIGGERING FULL RELOAD
        if (updatedPatient) {
          const age = calculateAge(updatedPatient.dob);
          const daysBetween = calculateDaysBetween(updatedPatient.dat, updatedPatient.d_dat);
          
          setClaimsData(prev => ({
            ...prev,
            surname: updatedPatient.surname || '',
            otherNames: updatedPatient.othername || '',
            gender: updatedPatient.gender || 'Select >>',
            firstVisit: updatedPatient.dat || '',
            age: age.toString(),
            membershipNo: updatedPatient.member_no || '',
            ccc: updatedPatient.ccc || '',
            secondVisit: updatedPatient.d_dat || '',
            nhisNo: daysBetween.toString()
          }));
          
          setIsDependant(updatedPatient.Dependant === 1);
        }

        // ✅ IF d_dat WAS UPDATED, RECALCULATE DAYS BETWEEN DATES
        if (field === 'd_dat' && value) {
          const daysBetween = calculateDaysBetween(claimsData.firstVisit, value);
          setClaimsData(prev => ({
            ...prev,
            secondVisit: value,
            nhisNo: daysBetween.toString()
          }));
        }

        setEditingField(null);
        setEditValue('');
        setShowDobPicker(false);
        
        setSnackbar({
          open: true,
          message: '✅ Patient information updated successfully!',
          severity: 'success'
        });
      } else {
        setSnackbar({
          open: true,
          message: `❌ Update failed: ${data.message}`,
          severity: 'error'
        });
      }
    } catch (err) {
      console.error('Failed to update patient:', err);
      setSnackbar({
        open: true,
        message: '❌ Failed to update patient. Please try again.',
        severity: 'error'
      });
    } finally {
      setLoading(false); // ✅ STOP LOADING
    }
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar({ ...snackbar, open: false });
  };




const loadDiagnosisOptions = async (age, gender, status) => {
  setLoadingDiagnosisOptions(true);
  try {
    const response = await axios.get(loadDiagnosisOptionsdb, {
      params: {
        age: age,
        gender: gender,
        status: status
      }
    });

    if (response.data.success) {
      setDiagnosisOptions(response.data.results);
    }
  } catch (error) {
    console.error('Error loading diagnosis options:', error);
  } finally {
    setLoadingDiagnosisOptions(false);
  }
};

const loadProcedureOptions = async (age, gender, status) => {
  setLoadingProcedureOptions(true);
  try {
    const response = await axios.get(loadProcedureOptionsdb, {
      params: {
        age: age,
        gender: gender,
        status: status
      }
    });

    if (response.data.success) {
      setprocedureOptions(response.data.results);
    }
  } catch (error) {
    console.error('Error loading procedure options:', error);
  } finally {
    setLoadingProcedureOptions(false);
  }
};

const loadPatientDiagnosis = async (patientId, dat ,v_dat) => {
  setLoading(true);
  try {
    const response = await axios.get(loadPatientDiagnosisclam, {
      params: { patientId, dat ,v_dat },
    });

    if (!response.data.success || !response.data.data) return;

    const { documenting, procedure_ } = response.data.data;

    // Load diagnoses
    if (documenting && documenting.trim() !== "") {
      const parsedDiagnosisNames = documenting
        .split(",")
        .map((item) => item.trim())
        .filter(name => name.length > 0);

      const matchedDiagnosis = diagnosisOptions.filter((opt) =>
        parsedDiagnosisNames.some(
          (parsedName) => opt.name.toLowerCase() === parsedName.toLowerCase()
        )
      );
      
      setSelectedDiagnoses(matchedDiagnosis);
    } else {
      setSelectedDiagnoses([]);
    }

    // Load procedures
    if (procedure_ && procedure_.trim() !== "") {
      const parsedProcedures = procedure_
        .split(",")
        .map((p) => p.trim())
        .filter(name => name.length > 0);

      const matchedProcedures = procedureOptions.filter((opt) =>
        parsedProcedures.some(
          (parsedName) => opt.name.toLowerCase() === parsedName.toLowerCase()
        )
      );

      setSelectedProcedures(matchedProcedures);
    } else {
      setSelectedProcedures([]);
    }

  } catch (error) {
    console.error("Error loading diagnosis:", error);
  } finally {
    setLoading(false);
  }
};

// Small toast for a non-blocking "saved" confirmation. Also used by the
// procedure save below so both actions look identical to the user.
const showSavedToast = (label) => {
  Swal.fire({
    toast: true,
    position: 'top-end',
    icon: 'success',
    title: `${label} saved`,
    showConfirmButton: false,
    timer: 1600,
    timerProgressBar: true,
  });
};

// Turn an axios error into a concise, user-actionable message so the user
// knows whether to retry, check the network, or call IT. Splits three
// buckets: network failure, request timeout, server-side error.
const explainSaveError = (err, verb) => {
  if (err?.code === 'ECONNABORTED' || /timeout/i.test(err?.message || '')) {
    return {
      title: 'Request timed out',
      html: `The ${verb} save didn't come back in time. This usually means the network is slow or the server is under heavy load.<br><br>Please try again in a moment.`,
    };
  }
  if (err?.message === 'Network Error' || !err?.response) {
    return {
      title: 'Network problem',
      html: `Couldn't reach the server to save the ${verb}. Please check your internet connection and try again.`,
    };
  }
  const status = err.response.status;
  const backendMsg = err.response?.data?.message;
  if (status >= 500) {
    return {
      title: 'Server error',
      html: `The server rejected the ${verb} save with a ${status} error.${backendMsg ? `<br><br><small>${backendMsg}</small>` : ''}<br><br>Please retry — if it happens again, contact support.`,
    };
  }
  return {
    title: `Couldn't save ${verb}`,
    html: backendMsg || `The server refused the ${verb} save (${status}). Nothing was changed.`,
  };
};

const saveOrUpdateDiagnosis = async (selectedDiagnosesList) => {
  if (!selectedPatientId) {
    console.warn("⚠️ No patient selected — cannot save diagnosis.");
    return;
  }

  setLoading(true);
  try {
    const patient = patients.find(p => p.patient_id === selectedPatientId);

    const response = await axios.post(saveOrUpdateDiagnosisDocumetingClami, {
      patientId: selectedPatientId,
      dat: claimsData.secondVisit,
      v_dat: claimsData.firstVisit,
      selectedDiagnoses: selectedDiagnosesList,
      gen: claimsData.gender,
      fullName: claimsData.surname + ' ' + claimsData.otherNames,
      age: claimsData.age,
      tel: patient?.tel || '',
      dob: patient?.dob || '',
      patientStatus: claimsData.patientState,
    }, { timeout: 20000 });  // 20s cap so a broken connection surfaces
                              // as a real error instead of hanging forever

    if (response.data.success) {
      // No full-panel reload after a diagnosis save. Nothing on the panel
      // needs to be re-fetched — the selection is already in
      // `selectedDiagnoses` local state, and none of the seven
      // patient-load endpoints depend on the diagnosis just written.
      // The previous setTimeout(..., 1500) + handlePatientSelect call
      // was pure dead time (~1.5s wait) plus 7 extra backend calls per
      // save. Removing them makes each save feel instantaneous.
      showSavedToast('Diagnosis');
    } else {
      // Backend replied 200 but success:false — treat as a soft error.
      Swal.fire({
        icon: 'warning',
        title: "Couldn't save diagnosis",
        html: response.data?.message || 'The server did not confirm the save. Please try again.',
      });
    }
  } catch (error) {
    console.error("❌ Error saving diagnosis:", error);
    const { title, html } = explainSaveError(error, 'diagnosis');
    Swal.fire({ icon: 'error', title, html });
  } finally {
    setLoading(false);
  }
};

const saveOrUpdateProcedure = async (selectedProceduresList) => {
  if (!selectedPatientId) {
    console.warn("⚠️ No patient selected — cannot save procedures.");
    return;
  }

  setLoading(true);
  try {
    const patient = patients.find(p => p.patient_id === selectedPatientId);

    const response = await axios.post(saveOrUpdateProcedureDocumetingClami, {
      patientId: selectedPatientId,
      dat: claimsData.secondVisit,
      v_dat: claimsData.firstVisit,
      selectedProcedures: selectedProceduresList,
      gen: claimsData.gender,
      fullName: claimsData.surname + ' ' + claimsData.otherNames,
      age: claimsData.age,
      tel: patient?.tel || '',
      dob: patient?.dob || '',
      patientStatus: claimsData.patientState,
      currentUser: currentUser,
    }, { timeout: 20000 });

    if (response.data.success) {
      // Same reasoning as saveOrUpdateDiagnosis above — no full-panel
      // reload, no 1.5s delay. Just confirm the save with a toast.
      showSavedToast('Procedure');
    } else {
      Swal.fire({
        icon: 'warning',
        title: "Couldn't save procedure",
        html: response.data?.message || 'The server did not confirm the save. Please try again.',
      });
    }
  } catch (error) {
    console.error("❌ Error saving procedures:", error);
    const { title, html } = explainSaveError(error, 'procedure');
    Swal.fire({ icon: 'error', title, html });
  } finally {
    setLoading(false);
  }
};




// Add the load lab options function
const loadLabOptions = async (insurance) => {
  setLoadingLabOptions(true);
  try {
    const response = await axios.get(loadLabdb, {
      params: {
        insurance: insurance
      }
    });

    if (response.data.success) {
      setLabOptions(response.data.results);
    }
  } catch (error) {
    console.error('Error loading lab options:', error);
  } finally {
    setLoadingLabOptions(false);
  }
};

// Add the load patient labs function
const loadPatientLabs = async (patientId, dat, v_dat) => {
  setLoading(true);
  try {
    const response = await axios.get(loadPatientLabsclim, {
      params: { patientId, dat, v_dat },
    });

    if (!response.data.success || !response.data.data) return;

    const { labs } = response.data.data;

    // Load labs
    if (labs && labs.trim() !== "") {
      const labNames = labs
        .split(",")
        .map((item) => item.trim())
        .filter(name => name.length > 0);

      const matchedLabs = labOptions.filter((opt) =>
        labNames.some(
          (parsedName) => opt.name.toLowerCase() === parsedName.toLowerCase()
        )
      );

      setSelectedLabs(matchedLabs);
    } else {
      setSelectedLabs([]);
    }

  } catch (error) {
    console.error("Error loading labs:", error);
  } finally {
    setLoading(false);
  }
};

// Add the save labs function
const saveOrUpdateLabs = async (selectedLabsList) => {
  if (!selectedPatientId) {
    console.warn("⚠️ No patient selected — cannot save labs.");
    return;
  }

  setLoading(true);
  try {
    const patient = patients.find(p => p.patient_id === selectedPatientId);
    
    const response = await axios.post(saveOrUpdateLabsClami, {
      patientId: selectedPatientId,
      dat: claimsData.secondVisit,
      v_dat: claimsData.firstVisit,
      selectedLabs: selectedLabsList,
      gen: claimsData.gender,
      fullName: claimsData.surname + ' ' + claimsData.otherNames,
      age: claimsData.age,
      tel: patient?.tel || '',
      dob: patient?.dob || '',
      patientStatus: claimsData.patientState,
      currentUser: currentUser
    });

    if (response.data.success) {
      console.log("✅ Labs saved successfully:", selectedLabsList);
      // ✅ NO RELOAD - just keep the state as is
    }
  } catch (error) {
    console.error("❌ Error saving labs:", error);
    Swal.fire("Error", "Failed to save labs", "error");
  } finally {
    setLoading(false);
  }
};


//Scan

// Add the load scan options function
const loadScanOptions = async (insurance) => {
  setLoadingScanOptions(true);
  try {
    const response = await axios.get(loadAvailableScanscilm, {
      params: {
        insurance: insurance
      }
    });

    if (response.data.success) {
      setScanOptions(response.data.results);
    }
  } catch (error) {
    console.error('Error loading scan options:', error);
  } finally {
    setLoadingScanOptions(false);
  }
};

// Add the load patient scans function
const loadPatientScans = async (patientId, dat, v_dat) => {
  setLoading(true);
  try {
    const response = await axios.get(loadPatientScansclam, {
      params: { patientId, dat, v_dat },
    });

    if (!response.data.success || !response.data.data) return;

    const { scans } = response.data.data;

    // Load scans
    if (scans && scans.trim() !== "") {
      const scanNames = scans
        .split(",")
        .map((item) => item.trim())
        .filter(name => name.length > 0);

      const matchedScans = scanOptions.filter((opt) =>
        scanNames.some(
          (parsedName) => opt.name.toLowerCase() === parsedName.toLowerCase()
        )
      );

      setSelectedScans(matchedScans);
    } else {
      setSelectedScans([]);
    }

  } catch (error) {
    console.error("Error loading scans:", error);
  } finally {
    setLoading(false);
  }
};

// Add the save scans function
const saveOrUpdateScans = async (selectedScansList) => {
  if (!selectedPatientId) {
    console.warn("⚠️ No patient selected — cannot save scans.");
    return;
  }

  setLoading(true);
  try {
    const patient = patients.find(p => p.patient_id === selectedPatientId);
    
    const response = await axios.post(saveOrUpdateScansClami, {
      patientId: selectedPatientId,
      dat: claimsData.secondVisit,
      v_dat: claimsData.firstVisit,
      selectedScans: selectedScansList,
      gen: claimsData.gender,
      fullName: claimsData.surname + ' ' + claimsData.otherNames,
      age: claimsData.age,
      tel: patient?.tel || '',
      dob: patient?.dob || '',
      patientStatus: claimsData.patientState,
      currentUser: currentUser
    });

    if (response.data.success) {
      console.log("✅ Scans saved successfully:", selectedScansList);
      // ✅ NO RELOAD - just keep the state as is
    }
  } catch (error) {
    console.error("❌ Error saving scans:", error);
    Swal.fire("Error", "Failed to save scans", "error");
  } finally {
    setLoading(false);
  }
};



// Medication

// ✅ LOAD REQUESTED MEDICATIONS

const loadRequestedMedications = async (patientId, dat, currentDate) => {
  setLoadingMeds(true);
  try {
    const response = await axios.get(loadRequestedMedsInpatient, {
      params: {
        patientId: patientId,
        dat: dat,
        currentDate: currentDate
      }
    });

    if (response.data.success) {
      setRequestedMeds(response.data.results);
      console.log("✅ Loaded requested medications:", response.data.results);
    } else {
      setRequestedMeds([]);
    }
  } catch (error) {
    console.error("❌ Error loading requested medications:", error);
    Swal.fire({
      title: "Error",
      text: "Failed to load requested medications",
      icon: "error",
    });
  } finally {
    setLoadingMeds(false);
  }
};


const handleAddMedication = async () => {

  //console.log(requestedMeds)
  // ------------------------------------
  // ✅ VALIDATION
  // ------------------------------------
  let hasError = false;

  if (!selectedMed) {
    ErrorMessage("Error", "Please select a medication first");
    return;
  }

  if (!doseAmount) {
    setDoseAmountError(true);
    hasError = true;
  }

  if (!frequency) {
    setFrequencyError(true);
    hasError = true;
  }

  if (!days || days <= 0) {
    setDaysError(true);
    hasError = true;
  }

  if (!route) {
    setRouteError(true);
    hasError = true;
  }

  // qty validation depending on autoCalculate
  if ((!autoCalculate && (!qty || qty <= 0)) || (autoCalculate && qty <= 0)) {
    setQtyError(true);
    hasError = true;
  }

  if (!medicationDate) {
  setMedicationDateError(true);
  return;
}


  if (hasError) return;

  // ------------------------------------
  // ✅ DUPLICATE-PREVENTION
  // ------------------------------------

 
  setLoading(true);
  try {
    const response = await axios.post(addMedicationdb, {
      patientId: claimsData.patientId,
      selectedMed,
      qty,
      frequency,
      route,
      doseAmount,
      days,
      currentUser,
      insurance: insuranceType,
      dat:medicationDate,
      age:claimsData.age,
      // Claims is a records desk, not the consulting room: the drug was
      // already dispensed and settled at the time of the visit. This tells
      // the server to save the row as paid + served instead of dropping it
      // into the cashier's outstanding list and the pharmacy's queue.
      source: 'claims'
    });

    // ------------------------------------
    // ✅ SUCCESS HANDLING
    // ------------------------------------
    if (response.data.success) {
      //successMessage("Success", "Medication added successfully");
     loadRequestedMedications(
      claimsData.patientId,
      claimsData.firstVisit,
      claimsData.secondVisit
    );
      handleClearMedication(); // reset inputs
    }
  } catch (err) {
    console.error('addMedication failed:', err);
    const serverMsg = err.response?.data?.message;
    ErrorMessage("Error", serverMsg || "Failed to save medication");
  }finally {
    setLoading(false);
  }
};


// Edit medication

const [EditMad , setEditMad] =useState()

const handleUpdateMedication = async () => {
  if (!EditMad || !EditMad.trans_code) {
    ErrorMessage("Error", "No medication selected for update.");
    return;
  }

  let hasError = false;

  if (!doseAmount) {
    setDoseAmountError(true);
    hasError = true;
  }
  if (!frequency) {
    setFrequencyError(true);
    hasError = true;
  }
  if (!days || days <= 0) {
    setDaysError(true);
    hasError = true;
  }
  if (!route) {
    setRouteError(true);
    hasError = true;
  }
  if ((!autoCalculate && (!qty || qty <= 0)) || (autoCalculate && qty <= 0)) {
    setQtyError(true);
    hasError = true;
  }


  if (!medicationDate) {
  setMedicationDateError(true);
  return;
}

  if (hasError) return;

  setLoading(false);
  try {
    const response = await axios.post(updateMedicationdb, {
      trans_code: EditMad.trans_code, // ✅ identify the record
      doseAmount,
      frequency,
      days,
      route,
      qty,
      currentUser,
      patientId: claimsData.patientId,
      insurance: insuranceType,
      dat:medicationDate,
    });

    if (response.data.success) {
      successMessage("Success", "Medication updated successfully");
    
      loadRequestedMedications(
      claimsData.patientId,
      claimsData.firstVisit,
      claimsData.secondVisit)

      handleClearMedication();
    } else {
      ErrorMessage("Error", response.data.message || "Failed to update medication");
    }
  } catch (error) {
    ErrorMessage("Error", "Unable to update medication");
    console.error("Update medication error:", error);
  }finally {
    setLoading(false);
  }
};



const handleEditMedication = (idx) => {
  const med = requestedMeds[idx];

  setEditMad(med)
  setSelectedMed({ name: med.drug });
  setDoseAmount(med.dose.split(" ")[0]);
  setDoseUnit(med.dose.split(" ")[1] || "");
  setFrequency(med.freq);
  setDays(med.days);
  setQty(med.qty);
  setRoute(med.route);
  setAutoCalculate(true);
  setEditingIndex(idx); // mark edit mode
};


const handleDeleteMedication = async (med) => {
  //console.log(med);

  // 1️⃣ Confirm delete
  setLoading(true);
  const confirmDelete = await Swal.fire({
    title: "Delete Medication?",
    text: `Are you sure you want to delete "${med.drug || "this medication"}"?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, delete",
    cancelButtonText: "No, cancel",
  });

  if (!confirmDelete.isConfirmed) {
     setLoading(false)
     return
  }  // user cancelled
  try {
    // 2️⃣ Send delete request (POST)
    const response = await axios.post( deleteMedicationclam, {
      trans_code: med.trans_code,
      patientId: claimsData.patientId,
      insurance: insurancetypes,
      dat: claimsData.secondVisit,
    });

   

    // 4️⃣ Successful deletion
    if (response.data.success) {
      Swal.fire("Deleted", response.data.message, "success");
      loadRequestedMedications(
      claimsData.patientId,
      claimsData.firstVisit,
      claimsData.secondVisit)
      return;
    }

    // 5️⃣ Backend returned an error
    Swal.fire(
      "Error",
      response.data.message || "Could not delete medication.",
      "error"
    );

  } catch (error) {
    console.error("DELETE MEDICATION ERROR:", error);
    Swal.fire("Error", "Something went wrong.", "error");
  }finally {
    setLoading(false);
  }
};


const handleClearMedication = () => {
  setSelectedMed(null);
  setDoseAmount("");
  setDoseUnit("");
  setFrequency("");
  setDays(1);
  setQty(0);
  setRoute("");
  setAutoCalculate(false);
  setEditingIndex(null);
  setMedicationDate("");
};


const loadAvailableMedications = async () => {
  if (!insuranceType) return;

  setLoadingAvailableMeds(true);
  try {
    const res = await axios.get(loadMedicationsCalim, {
      params: {
        insurance: insuranceType
      }
    });

    if (res.data.success) {
       setMedications(res.data.results || []);
      console.log("✅ Available meds:", res.data.results);
    } else {
      setMedications([]);
    }
  } catch (err) {
    console.error("❌ Failed to load available medications", err);
    setMedications([]);
  } finally {
    setLoadingAvailableMeds(false);
  }
};


const loadLastMedicationPattern = async (selectedMedName, patientAge) => {
  try {
    const ageGroup = patientAge >= 12 ? "adult" : "child";

    const res = await axios.get(loadMedicationByAge, {
      params: { name: selectedMedName, age:ageGroup }
    });

    if (res.data.success) {
      const p = res.data.med;

      // 🔥 Auto-fill only if backend found data
      setDoseAmount(p.dose);
      setFrequency(p.freq);
      setDays(p.day_server);
      setRoute(p.rou);
      setQty(p.qua);

      
    }else {
      setDoseAmount('');
      setFrequency('');
      setDays('');
      setRoute('');
      setQty('');
    }
  } catch (error) {
    console.log("Error loading medication pattern:", error);
  }
};

const extractStrengthFromName = (name) => {
  if (!name) return { medName: "", medStrength: "" };

  loadLastMedicationPattern(name, claimsData.age);

  let medName = name.trim();
  let medStrength = "";

  // Case 1: If there is a comma, assume strength is after the last comma
  if (name.includes(",")) {
    const parts = name.split(",");
    medName = parts.slice(0, -1).join(",").trim();
    medStrength = parts[parts.length - 1].trim();
  } else {
    // Case 2: If it ends with (...) → treat last parentheses as strength
    const parenMatch = name.match(/^(.*)\(([^()]*)\)\s*$/);
    if (parenMatch) {
      medName = parenMatch[1].trim();
      medStrength = parenMatch[2].trim();
    } else {
      // Case 3: Try to match trailing numeric + unit like "80mg/mL", "0.5%", "125mls"
      const match = name.match(/(.*?)(\d+(?:\.\d+)?\s?(?:mg\/ml|mg|g|mcg|ml|mls|%|units?|iu))$/i);
      if (match) {
        medName = match[1].trim();
        medStrength = match[2].trim();
      }
    }
  }

  return { medName, medStrength };

  
};

const handleSelectMedication = (med) => {
  setSelectedMed(med);
  
  // ✅ Check if this medication exists in chronic meds with flexible matching
  const chronicMed = chronicMeds && chronicMeds.length > 0 
    ? chronicMeds.find(cm => {
        if (!cm || !cm.medication || !med || !med.name) return false;
        
        const normalizedChronicName = cm.medication.toLowerCase().trim().replace(/\s+/g, ' ');
        const normalizedMedName = med.name.toLowerCase().trim().replace(/\s+/g, ' ');
        
        // Try exact match first
        if (normalizedChronicName === normalizedMedName) {
          return true;
        }
        
        // Try partial match
        return normalizedMedName.includes(normalizedChronicName) || 
               normalizedChronicName.includes(normalizedMedName);
      })
    : null;

  if (chronicMed) {
    // ✅ Auto-fill with chronic medication details
    console.log("✅ Chronic medication found:", chronicMed);
    
    const doseString = chronicMed.dose || "";
    const doseParts = doseString.split(" ");
    setDoseAmount(doseParts[0] || "");
    setDoseUnit(doseParts[1] || "");
    
    setFrequency(chronicMed.freq || "");
    setDays(chronicMed.days || "");
    setQty(chronicMed.qty || 0);
    setRoute(chronicMed.route || "");
    setAutoCalculate(true);
  } else {
    // ✅ Regular flow
    const { medStrength } = extractStrengthFromName(med.name);
    setDoseUnit(medStrength || "");
    setAutoCalculate(isSolidByName(med.name) || isAutoCalcUnit(medStrength));
    
    if (selectedPatient && selectedPatient.age) {
      loadLastMedicationPattern(med.name, selectedPatient.age);
    }
  }
};

const loadRequestedMeds = async () => {
   setLoading(true);
  try {
    const response = await axios.get(loadRequestedMedsdb, {
      params: { patientId: selectedPatient.id , dat:selectedPatient.visitDate, }
    });

    if (response.data.success) {
      setRequestedMeds(response.data.results);
    }
  } catch (err) {
    console.error("Error loading meds:", err);
  }finally {
    setLoading(false);
  }
};


const generateDateRange = (start, end) => {
  if (!start || !end) return [];

  const dates = [];
  let current = new Date(start);
  const last = new Date(end);

  while (current <= last) {
    dates.push(current.toISOString().split("T")[0]);
    current.setDate(current.getDate() + 1);
  }

  return dates;
};


const medicationDates = generateDateRange(
  claimsData.firstVisit,
  claimsData.secondVisit
);


const filteredRequestedMeds =
    medicationDate === "ALL" || !medicationDate
      ? requestedMeds
      : requestedMeds.filter(m => m.date === medicationDate);


  return (
    <Box sx={{ 
      display: 'flex',
      flexDirection: { xs: 'column', md: 'row' },
      gap: 2.5,
      p: { xs: 1.5, sm: 2, md: 3 },
      minHeight: '100vh',
      bgcolor: '#f8f9fa',
      height: { md: '100vh' },
      overflow: 'hidden'
    }}>
      {/* Loading Overlay */}
      {loading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            bgcolor: "rgba(0,0,0,0.4)",
            backdropFilter: "blur(2px)",
            zIndex: 2000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <CircularProgress size={70} thickness={5} />
        </Box>
      )}

      {/* ─────────────────────────────────────────────────────────────
          LEFT COLUMN — Claim Filters + Patient List
          Redesigned Nov 2026: unified palette on #1A9B7F (was mixed
          #1A9B7F gradients), split into two sticky/scrollable cards so
          the filters stay pinned while a long patient list scrolls
          independently. Every state binding and handler is preserved.
         ───────────────────────────────────────────────────────────── */}
      <Fade in timeout={400}>
        <Box sx={{
          width: { xs: '100%', md: 460 },
          flexShrink: 0,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          height: { md: 'calc(100vh - 48px)' },
          overflow: 'hidden',
        }}>
          {/* ── Filters card ────────────────────────────────────── */}
          <Paper
            elevation={0}
            sx={{
              p: 2.25,
              borderRadius: 2.5,
              border: '1px solid #e5e9ef',
              bgcolor: '#fff',
              flexShrink: 0,
            }}
          >
            <Typography sx={{
              fontSize: '0.72rem',
              fontWeight: 700,
              letterSpacing: '1.2px',
              textTransform: 'uppercase',
              color: '#1A9B7F',
              mb: 0.25,
            }}>
              Claim Filters
            </Typography>
            <Typography sx={{ fontSize: '0.82rem', color: '#64748b', mb: 2 }}>
              Pick an insurance scheme and month to load the worklist.
            </Typography>

            <Stack spacing={1.75}>
              {loadingInsurance ? (
                <Skeleton variant="rectangular" height={40} sx={{ borderRadius: 1.75 }} />
              ) : (
                <FormControl fullWidth size="small" error={!!errorInsurance}>
                  <InputLabel>Insurance Type</InputLabel>
                  <Select
                    value={insuranceType}
                    label="Insurance Type"
                    onChange={(e) => setInsuranceType(e.target.value)}
                    sx={{ borderRadius: 1.75, bgcolor: '#fff' }}
                  >
                    <MenuItem value=""><em>Select insurance</em></MenuItem>
                    {insuranceTypes.map((row, index) => (
                      <MenuItem key={index} value={row.scheme_name}>
                        {row.scheme_name}
                      </MenuItem>
                    ))}
                  </Select>
                  {errorInsurance && (
                    <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1 }}>
                      {errorInsurance}
                    </Typography>
                  )}
                </FormControl>
              )}

              <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1.5 }}>
                {loadingMonths ? (
                  <Skeleton variant="rectangular" height={40} sx={{ borderRadius: 1.75 }} />
                ) : (
                  <FormControl fullWidth size="small" error={!!errorMonths}>
                    <InputLabel>Month / Year</InputLabel>
                    <Select
                      value={selectedMonth}
                      label="Month / Year"
                      onChange={(e) => setSelectedMonth(e.target.value)}
                      sx={{ borderRadius: 1.75, bgcolor: '#fff' }}
                    >
                      <MenuItem value=""><em>Month</em></MenuItem>
                      {claimMonths.map((row, index) => (
                        <MenuItem key={index} value={row.value}>{row.label}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}

                {loadingDates ? (
                  <Skeleton variant="rectangular" height={40} sx={{ borderRadius: 1.75 }} />
                ) : (
                  <FormControl fullWidth size="small" disabled={!selectedMonth} error={!!errorDates}>
                    <InputLabel>Date</InputLabel>
                    <Select
                      value={selectedDate}
                      label="Date"
                      onChange={(e) => setSelectedDate(e.target.value)}
                      sx={{ borderRadius: 1.75, bgcolor: '#fff' }}
                    >
                      <MenuItem value=""><em>Any</em></MenuItem>
                      {claimDates.map((row, index) => (
                        <MenuItem key={index} value={row.claim_date}>{row.claim_date}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
              </Box>

              <Button
                fullWidth
                variant="text"
                size="small"
                onClick={() => setShowAdvancedFilters(!showAdvancedFilters)}
                startIcon={<FilterListIcon sx={{ fontSize: 16 }} />}
                endIcon={showAdvancedFilters ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                sx={{
                  borderRadius: 1.5,
                  color: '#1A9B7F',
                  textTransform: 'none',
                  fontWeight: 600,
                  fontSize: '0.8rem',
                  justifyContent: 'space-between',
                  py: 0.75,
                  px: 1,
                  '&:hover': { bgcolor: 'rgba(26,155,127,0.08)' },
                }}
              >
                {showAdvancedFilters ? 'Hide advanced filters' : 'Show advanced filters'}
              </Button>

              {(selectedService || selectedDiagnosis || selectedProcedure || selectedMedication) && (
                <Box sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  px: 1.25,
                  py: 0.75,
                  bgcolor: 'rgba(26,155,127,0.08)',
                  border: '1px solid rgba(26,155,127,0.25)',
                  borderRadius: 1.5,
                }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                    <Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: '#1A9B7F' }} />
                    <Typography sx={{ fontSize: '0.72rem', fontWeight: 700, color: '#127a63' }}>
                      {[selectedService, selectedDiagnosis, selectedProcedure, selectedMedication].filter(Boolean).length} advanced filter
                      {[selectedService, selectedDiagnosis, selectedProcedure, selectedMedication].filter(Boolean).length > 1 ? 's' : ''} active
                    </Typography>
                  </Box>
                  <Button
                    size="small"
                    onClick={() => {
                      setSelectedService('');
                      setSelectedDiagnosis('');
                      setSelectedProcedure('');
                      setSelectedMedication('');
                    }}
                    sx={{
                      minWidth: 'auto',
                      p: '2px 8px',
                      fontSize: '0.68rem',
                      fontWeight: 700,
                      color: '#b91c1c',
                      textTransform: 'none',
                      borderRadius: 1,
                      '&:hover': { bgcolor: 'rgba(185,28,28,0.08)' },
                    }}
                    startIcon={<CloseIcon sx={{ fontSize: '0.75rem !important' }} />}
                  >
                    Clear
                  </Button>
                </Box>
              )}

              {showAdvancedFilters && (
                <Stack spacing={1.5}>
                  {loadingServices ? (
                    <Skeleton variant="rectangular" height={40} sx={{ borderRadius: 1.75 }} />
                  ) : (
                    <FormControl fullWidth size="small" disabled={!insuranceType || !selectedMonth}>
                      <InputLabel>Service Provided</InputLabel>
                      <Select
                        value={selectedService}
                        label="Service Provided"
                        onChange={(e) => setSelectedService(e.target.value)}
                        sx={{ borderRadius: 1.75, bgcolor: '#fff' }}
                      >
                        <MenuItem value=""><em>Any service</em></MenuItem>
                        {servicesProvidedList.map((row, index) => (
                          <MenuItem key={index} value={row.which}>{row.which}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}

                  {loadingDiagnosis ? (
                    <Skeleton variant="rectangular" height={40} sx={{ borderRadius: 1.75 }} />
                  ) : (
                    <FormControl fullWidth size="small" disabled={!insuranceType || !selectedMonth}>
                      <InputLabel>Filtered Diagnosis</InputLabel>
                      <Select
                        value={selectedDiagnosis}
                        label="Filtered Diagnosis"
                        onChange={(e) => setSelectedDiagnosis(e.target.value)}
                        sx={{ borderRadius: 1.75, bgcolor: '#fff' }}
                      >
                        <MenuItem value=""><em>Any diagnosis</em></MenuItem>
                        {diagnosisList.map((row, index) => (
                          <MenuItem key={index} value={row.diagnosis}>{row.diagnosis}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}

                  {loadingProcedures ? (
                    <Skeleton variant="rectangular" height={40} sx={{ borderRadius: 1.75 }} />
                  ) : (
                    <FormControl fullWidth size="small" disabled={!insuranceType || !selectedMonth}>
                      <InputLabel>Filtered Procedure</InputLabel>
                      <Select
                        value={selectedProcedure}
                        label="Filtered Procedure"
                        onChange={(e) => setSelectedProcedure(e.target.value)}
                        sx={{ borderRadius: 1.75, bgcolor: '#fff' }}
                      >
                        <MenuItem value=""><em>Any procedure</em></MenuItem>
                        {procedureList.map((row, index) => (
                          <MenuItem key={index} value={row.procedure_name}>{row.procedure_name}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}

                  {loadingMedications ? (
                    <Box sx={{ position: 'relative' }}>
                      <Skeleton variant="rectangular" height={40} sx={{ borderRadius: 1.75 }} />
                      <Box sx={{
                        position: 'absolute', top: '50%', left: '50%',
                        transform: 'translate(-50%, -50%)',
                        display: 'flex', alignItems: 'center', gap: 1,
                      }}>
                        <CircularProgress size={16} sx={{ color: '#1A9B7F' }} />
                        <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 600 }}>
                          Loading medications…
                        </Typography>
                      </Box>
                    </Box>
                  ) : (
                    <FormControl fullWidth size="small" disabled={!insuranceType || !selectedMonth}>
                      <InputLabel>Filtered Medication</InputLabel>
                      <Select
                        value={selectedMedication}
                        label="Filtered Medication"
                        onChange={(e) => setSelectedMedication(e.target.value)}
                        sx={{ borderRadius: 1.75, bgcolor: '#fff' }}
                      >
                        <MenuItem value=""><em>Any medication</em></MenuItem>
                        {medicationList.map((row, index) => (
                          <MenuItem key={index} value={row.name}>{row.name}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}
                </Stack>
              )}
            </Stack>
          </Paper>

          {/* ── Patient list card ───────────────────────────────── */}
          <Paper
            elevation={0}
            sx={{
              flex: 1,
              minHeight: 0,
              display: 'flex',
              flexDirection: 'column',
              borderRadius: 2.5,
              border: '1px solid #e5e9ef',
              bgcolor: '#fff',
              overflow: 'hidden',
            }}
          >
            {/* Header — status filter chips + count */}
            <Box sx={{
              p: 2,
              borderBottom: '1px solid #eef2f6',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 1.5,
              flexWrap: 'wrap',
            }}>
              <Stack direction="row" spacing={0.75}>
                {['All', 'Outpatient', 'Inpatient'].map((k) => {
                  const active = patientStateFilter === k;
                  return (
                    <Chip
                      key={k}
                      label={k}
                      onClick={() => setPatientStateFilter(k)}
                      size="small"
                      sx={{
                        height: 28,
                        px: 0.5,
                        fontWeight: 700,
                        fontSize: '0.75rem',
                        cursor: 'pointer',
                        bgcolor: active ? '#1A9B7F' : '#fff',
                        color: active ? '#fff' : '#334155',
                        border: '1px solid',
                        borderColor: active ? '#1A9B7F' : '#e5e9ef',
                        '&:hover': {
                          bgcolor: active ? '#127a63' : 'rgba(26,155,127,0.08)',
                          borderColor: '#1A9B7F',
                        },
                      }}
                    />
                  );
                })}
              </Stack>
              {filteredPatients.length > 0 && (
                <Chip
                  label={`${filteredPatients.length} patient${filteredPatients.length !== 1 ? 's' : ''}`}
                  size="small"
                  sx={{
                    height: 24,
                    fontWeight: 700,
                    fontSize: '0.72rem',
                    bgcolor: 'rgba(26,155,127,0.1)',
                    color: '#127a63',
                    border: '1px solid rgba(26,155,127,0.25)',
                  }}
                />
              )}
            </Box>

            {/* Search */}
            <Box sx={{ p: 1.25, borderBottom: '1px solid #eef2f6' }}>
              <TextField
                fullWidth
                size="small"
                placeholder="Search by name or ID…"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon fontSize="small" sx={{ color: '#94a3b8' }} />
                    </InputAdornment>
                  ),
                  endAdornment: searchTerm && (
                    <InputAdornment position="end">
                      <IconButton size="small" onClick={() => setSearchTerm('')} sx={{ color: '#94a3b8' }}>
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 1.75,
                    bgcolor: '#f8fafc',
                    '& fieldset': { borderColor: '#e5e9ef' },
                    '&:hover fieldset': { borderColor: '#cbd5e1' },
                    '&.Mui-focused fieldset': { borderColor: '#1A9B7F' },
                  },
                }}
              />
            </Box>

            {/* Scrollable list */}
            <Box sx={{
              flex: 1,
              overflowY: 'auto',
              minHeight: 0,
              '&::-webkit-scrollbar': { width: 6 },
              '&::-webkit-scrollbar-track': { background: 'transparent' },
              '&::-webkit-scrollbar-thumb': { background: '#cbd5e1', borderRadius: 3 },
            }}>
              {loadingPatients ? (
                <Stack spacing={0} sx={{ p: 0 }}>
                  {[...Array(6)].map((_, i) => (
                    <Box key={i} sx={{
                      display: 'flex', alignItems: 'center', gap: 1.25,
                      px: 2, py: 1.5, borderBottom: '1px solid #f1f5f9',
                    }}>
                      <Skeleton variant="circular" width={34} height={34} />
                      <Box sx={{ flex: 1 }}>
                        <Skeleton variant="text" width="60%" />
                        <Skeleton variant="text" width="35%" />
                      </Box>
                      <Skeleton variant="rounded" width={78} height={22} />
                    </Box>
                  ))}
                </Stack>
              ) : errorPatients ? (
                <Alert severity="error" sx={{ m: 2, borderRadius: 1.5 }}>{errorPatients}</Alert>
              ) : filteredPatients.length === 0 ? (
                <Box sx={{
                  display: 'flex', flexDirection: 'column',
                  alignItems: 'center', justifyContent: 'center',
                  py: 6, px: 2, textAlign: 'center',
                }}>
                  <PersonIcon sx={{ fontSize: 40, color: '#cbd5e1', mb: 1 }} />
                  <Typography sx={{ fontSize: '0.88rem', color: '#64748b', fontWeight: 500 }}>
                    {insuranceType && selectedMonth
                      ? 'No patients match your filters.'
                      : 'Choose an insurance scheme and month to load patients.'}
                  </Typography>
                </Box>
              ) : (
                paginatedPatients.map((patient, index) => {
                  const rowKey = visitKeyOf(patient);
                  const isSelected = selectedVisitKey === rowKey;
                  return (
                    <Box
                      key={rowKey || index}
                      onClick={() => handlePatientSelect(patient)}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1.25,
                        px: 2,
                        py: 1.25,
                        cursor: 'pointer',
                        borderLeft: '3px solid',
                        borderLeftColor: isSelected ? '#1A9B7F' : 'transparent',
                        borderBottom: '1px solid #f1f5f9',
                        bgcolor: isSelected ? 'rgba(26,155,127,0.08)' : 'transparent',
                        transition: 'background-color .15s ease, border-color .15s ease',
                        '&:hover': {
                          bgcolor: isSelected ? 'rgba(26,155,127,0.12)' : '#f8fafc',
                        },
                      }}
                    >
                      <Avatar sx={{
                        width: 34, height: 34,
                        bgcolor: isSelected ? '#1A9B7F' : 'rgba(26,155,127,0.14)',
                        color: isSelected ? '#fff' : '#127a63',
                        fontSize: '0.85rem', fontWeight: 700,
                      }}>
                        {patient.patient_name?.charAt(0) || 'P'}
                      </Avatar>
                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography sx={{
                          fontSize: '0.88rem',
                          fontWeight: isSelected ? 700 : 600,
                          color: '#0f172a',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                        }}>
                          {patient.patient_name}
                        </Typography>
                        <Typography sx={{
                          fontSize: '0.72rem',
                          fontWeight: 600,
                          color: '#1A9B7F',
                          letterSpacing: '0.3px',
                        }}>
                          {patient.patient_id}
                        </Typography>
                      </Box>
                      <Chip
                        label={patient.d_dat}
                        size="small"
                        sx={{
                          height: 22,
                          fontSize: '0.7rem',
                          fontWeight: 600,
                          bgcolor: isSelected ? '#1A9B7F' : '#f1f5f9',
                          color: isSelected ? '#fff' : '#475569',
                          border: 'none',
                        }}
                      />
                    </Box>
                  );
                })
              )}
            </Box>

            {/* Footer pager */}
            {filteredPatients.length > 0 && (
              <Box sx={{
                borderTop: '1px solid #eef2f6',
                px: 1.5,
                py: 0.5,
                bgcolor: '#fafbfc',
              }}>
                <TablePagination
                  component="div"
                  count={filteredPatients.length}
                  page={page}
                  onPageChange={handleChangePage}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  ActionsComponent={TablePaginationActions}
                  sx={{
                    border: 'none',
                    '& .MuiTablePagination-toolbar': { minHeight: 44, px: 0 },
                    '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                      fontSize: '0.72rem', fontWeight: 600, color: '#475569',
                    },
                  }}
                />
              </Box>
            )}
          </Paper>
        </Box>
      </Fade>

      {/* ─────────────────────────────────────────────────────────────
          RIGHT COLUMN — Patient Info + Claims Info + Care Services
          Redesigned Nov 2026: unified palette, flat Papers, thinner
          scrollbar. Every state binding and handler is preserved.
         ───────────────────────────────────────────────────────────── */}
      <Box sx={{
        flexGrow: 1,
        minWidth: 0,
        height: { md: 'calc(100vh - 48px)' },
        overflowY: 'auto',
        overflowX: 'hidden',
        '&::-webkit-scrollbar':       { width: 6 },
        '&::-webkit-scrollbar-track': { background: 'transparent' },
        '&::-webkit-scrollbar-thumb': { background: '#cbd5e1', borderRadius: 3 },
      }}>
        <Stack spacing={2}>
          {/* Patient Information Section */}
          <Fade in timeout={800}>
            <Paper 
              elevation={0}
              sx={{
                p: 2.5,
                borderRadius: 2.5,
                border: '1px solid #e5e9ef',
                bgcolor: '#fff',
              }}
            >
              <SectionHeader number={1} title="Patient Information" icon={PersonIcon} />

              <Box sx={{ 
                display: 'grid',
                gridTemplateColumns: { 
                  xs: '1fr',
                  sm: 'repeat(2, 1fr)',
                  md: 'repeat(3, 1fr)',
                  lg: 'repeat(4, 1fr)'
                },
                gap: 2
              }}>
                <TextField
                  fullWidth
                  size="small"
                  label="Surname"
                  value={claimsData.surname}
                  onChange={(e) => handleInputChange('surname', e.target.value)}
                  InputProps={{
                    endAdornment: selectedPatientId && (
                      <InputAdornment position="end">
                        <IconButton
                          size="small"
                          onClick={() => handleUpdateField('surname', claimsData.surname)}
                          sx={{
                            color: '#1A9B7F',
                            '&:hover': { bgcolor: 'rgba(26, 155, 127, 0.08)' }
                          }}
                        >
                          <EditIcon sx={{ fontSize: 16 }} />
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                />

                <TextField
                  fullWidth
                  size="small"
                  label="Other Name (s)"
                  value={claimsData.otherNames}
                  onChange={(e) => handleInputChange('otherNames', e.target.value)}
                  InputProps={{
                    endAdornment: selectedPatientId && (
                      <InputAdornment position="end">
                        <IconButton
                          size="small"
                          onClick={() => handleUpdateField('othername', claimsData.otherNames)}
                          sx={{
                            color: '#1A9B7F',
                            '&:hover': { bgcolor: 'rgba(26, 155, 127, 0.08)' }
                          }}
                        >
                          <EditIcon sx={{ fontSize: 16 }} />
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                />

                <TextField
                  fullWidth
                  size="small"
                  label="Patient ID"
                  value={claimsData.patientId}
                  disabled
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                />

                <FormControl fullWidth size="small">
                  <InputLabel>Gender</InputLabel>
                  <Select
                    value={claimsData.gender}
                    label="Gender"
                    onChange={(e) => handleInputChange('gender', e.target.value)}
                    endAdornment={selectedPatientId && (
                      <InputAdornment position="end" sx={{ mr: 3 }}>
                        <IconButton
                          size="small"
                          onClick={() => handleUpdateField('gender', claimsData.gender)}
                          sx={{
                            color: '#1A9B7F',
                            '&:hover': { bgcolor: 'rgba(26, 155, 127, 0.08)' }
                          }}
                        >
                          <EditIcon sx={{ fontSize: 16 }} />
                        </IconButton>
                      </InputAdornment>
                    )}
                    sx={{ borderRadius: 2 }}
                  >
                    <MenuItem value="Select >>">Select</MenuItem>
                    <MenuItem value="Male">Male</MenuItem>
                    <MenuItem value="Female">Female</MenuItem>
                    <MenuItem value="Other">Other</MenuItem>
                  </Select>
                </FormControl>

                <TextField
                  fullWidth
                  size="small"
                  label="1st Visit"
                  type="date"
                  value={claimsData.firstVisit}
                  onChange={(e) => handleInputChange('firstVisit', e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    endAdornment: selectedPatientId && (
                      <InputAdornment position="end">
                        <IconButton
                          size="small"
                          onClick={() => handleUpdateField('dat', claimsData.firstVisit)}
                          sx={{
                            color: '#1A9B7F',
                            '&:hover': { bgcolor: 'rgba(26, 155, 127, 0.08)' }
                          }}
                        >
                          <EditIcon sx={{ fontSize: 16 }} />
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                />

                <TextField
                  fullWidth
                  size="small"
                  label="2nd Visit"
                  type="date"
                  value={claimsData.secondVisit}
                  onChange={(e) => handleInputChange('secondVisit', e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    endAdornment: selectedPatientId && (
                      <InputAdornment position="end">
                        <IconButton
                          size="small"
                          onClick={() => handleUpdateField('d_dat', claimsData.secondVisit)}
                          sx={{
                            color: '#1A9B7F',
                            '&:hover': { bgcolor: 'rgba(26, 155, 127, 0.08)' }
                          }}
                        >
                          <EditIcon sx={{ fontSize: 16 }} />
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                />

                {showDobPicker && selectedPatientId ? (
                  <TextField
                    fullWidth
                    size="small"
                    label="Date of Birth"
                    type="date"
                    value={editValue}
                    onChange={(e) => setEditValue(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Stack direction="row" spacing={0.5}>
                            <IconButton
                              size="small"
                              onClick={() => {
                                handleUpdateField('dob', editValue);
                              }}
                              sx={{
                                color: '#1A9B7F',
                                '&:hover': { bgcolor: 'rgba(26, 155, 127, 0.08)' }
                              }}
                            >
                              <EditIcon sx={{ fontSize: 16 }} />
                            </IconButton>
                            <IconButton
                              size="small"
                              onClick={() => {
                                setShowDobPicker(false);
                                setEditValue('');
                              }}
                              sx={{
                                color: '#f44336',
                                '&:hover': { bgcolor: 'rgba(244, 67, 54, 0.08)' }
                              }}
                            >
                              <CloseIcon sx={{ fontSize: 16 }} />
                            </IconButton>
                          </Stack>
                        </InputAdornment>
                      )
                    }}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                  />
                ) : (
                  <TextField
                    fullWidth
                    size="small"
                    label="Age"
                    value={claimsData.age}
                    disabled
                    InputProps={{
                      endAdornment: selectedPatientId && (
                        <InputAdornment position="end">
                          <IconButton
                            size="small"
                            onClick={() => {
                              setShowDobPicker(true);
                              const currentPatient = patients.find(p => p.patient_id === selectedPatientId);
                              setEditValue(currentPatient?.dob || '');
                            }}
                            sx={{
                              color: '#1A9B7F',
                              '&:hover': { bgcolor: 'rgba(26, 155, 127, 0.08)' }
                            }}
                          >
                            <EditIcon sx={{ fontSize: 16 }} />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                  />
                )}

                 <TextField
                  fullWidth
                  size="small"
                  label="Membership NO."
                  value={claimsData.membershipNo}
                  onChange={(e) => handleInputChange('membershipNo', e.target.value)}
                  InputProps={{
                    endAdornment: selectedPatientId && (
                      <InputAdornment position="end">
                        <IconButton
                          size="small"
                          onClick={() => handleUpdateField('member_no', claimsData.membershipNo)}
                          sx={{
                            color: '#1A9B7F',
                            '&:hover': { bgcolor: 'rgba(26, 155, 127, 0.08)' }
                          }}
                        >
                          <EditIcon sx={{ fontSize: 16 }} />
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                />
                
                <TextField
                  fullWidth
                  size="small"
                  label="N.O."
                  value={claimsData.nhisNo}
                  onChange={(e) => handleInputChange('nhisNo', e.target.value)}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                />
                
                <TextField
                  fullWidth
                  size="small"
                  label="Patient State"
                  value={claimsData.patientState}
                  onChange={(e) => handleInputChange('patientState', e.target.value)}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                />

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Typography variant="body2" fontWeight={600} color="text.secondary">
                    Dependant:
                  </Typography>
                  <Stack direction="row" spacing={0.5} alignItems="center">
                    <Chip 
                      label="Yes" 
                      size="small" 
                      onClick={() => selectedPatientId && setIsDependant(true)}
                      sx={{ 
                        bgcolor: isDependant ? '#1A9B7F' : 'transparent',
                        color: isDependant ? 'white' : 'inherit',
                        fontWeight: isDependant ? 600 : 400,
                        cursor: selectedPatientId ? 'pointer' : 'default',
                        border: '1px solid',
                        borderColor: isDependant ? '#1A9B7F' : 'rgba(0,0,0,0.23)'
                      }}
                    />
                    <Chip 
                      label="No" 
                      size="small" 
                      onClick={() => selectedPatientId && setIsDependant(false)}
                      sx={{
                        bgcolor: !isDependant ? '#1A9B7F' : 'transparent',
                        color: !isDependant ? 'white' : 'inherit',
                        fontWeight: !isDependant ? 600 : 400,
                        cursor: selectedPatientId ? 'pointer' : 'default',
                        border: '1px solid',
                        borderColor: !isDependant ? '#1A9B7F' : 'rgba(0,0,0,0.23)'
                      }}
                    />
                    {selectedPatientId && (
                      <IconButton
                        size="small"
                        onClick={() => handleUpdateField('Dependant', isDependant ? 1 : 0)}
                        sx={{
                          color: '#1A9B7F',
                          ml: 0.5,
                          '&:hover': { bgcolor: 'rgba(26, 155, 127, 0.08)' }
                        }}
                      >
                        <EditIcon sx={{ fontSize: 16 }} />
                      </IconButton>
                    )}
                  </Stack>
                </Box>
            
                <TextField
                  fullWidth
                  size="small"
                  label="CCC"
                  value={claimsData.ccc}
                  onChange={(e) => handleInputChange('ccc', e.target.value)}
                  InputProps={{
                    endAdornment: selectedPatientId && (
                      <InputAdornment position="end">
                        <IconButton
                          size="small"
                          onClick={() => handleUpdateField('ccc', claimsData.ccc)}
                          sx={{
                            color: '#1A9B7F',
                            '&:hover': { bgcolor: 'rgba(26, 155, 127, 0.08)' }
                          }}
                        >
                          <EditIcon sx={{ fontSize: 16 }} />
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                />
              </Box>
            </Paper>
          </Fade>

          {/* Claims Information Section */}
          <Fade in timeout={1000}>
            <Paper 
              elevation={0}
              sx={{
                p: 2.5,
                borderRadius: 2.5,
                border: '1px solid #e5e9ef',
                bgcolor: '#fff',
              }}
            >
              <SectionHeader number={2} title="Claims Information" icon={HospitalIcon} />

              <Box sx={{ 
                display: 'grid', 
                gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
                gap: 2.5, 
                mb: 3
              }}>

                
                <Stack spacing={2}>
  <Box sx={{ 
    border: '1px solid rgba(0,0,0,0.23)', 
    borderRadius: 2, 
    p: 2 
  }}>
    <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 1.5 }}>
      Type of Service
    </Typography>
    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 1 }}>
      <FormControlLabel
        control={
          <Checkbox 
            size="small" 
            checked={serviceTypeChecks.outPatient}
            onChange={(e) => setServiceTypeChecks(prev => ({ ...prev, outPatient: e.target.checked }))}
          />
        }
        label="Out-Patient"
        sx={{ '& .MuiTypography-root': { fontSize: '0.875rem' } }}
      />
      <FormControlLabel
        control={
          <Checkbox 
            size="small" 
            checked={serviceTypeChecks.inPatient}
            onChange={(e) => setServiceTypeChecks(prev => ({ ...prev, inPatient: e.target.checked }))}
          />
        }
        label="In-Patient"
        sx={{ '& .MuiTypography-root': { fontSize: '0.875rem' } }}
      />
      <FormControlLabel
        control={
          <Checkbox 
            size="small" 
            checked={serviceTypeChecks.pharmacy}
            onChange={(e) => setServiceTypeChecks(prev => ({ ...prev, pharmacy: e.target.checked }))}
          />
        }
        label="Pharmacy"
        sx={{ '& .MuiTypography-root': { fontSize: '0.875rem' } }}
      />
    </Box>
    
    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 1, mt: 1 }}>
      <FormControlLabel
        control={
          <Checkbox 
            size="small" 
            checked={serviceTypeChecks.allInclusive}
            onChange={(e) => setServiceTypeChecks(prev => ({ ...prev, allInclusive: e.target.checked }))}
          />
        }
        label="All Inclusive"
        sx={{ '& .MuiTypography-root': { fontSize: '0.875rem' } }}
      />
    </Box>

    <Divider sx={{ my: 1.5 }} />

    <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 1.5 }}>
      Outcome
    </Typography>
    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 1 }}>
      <FormControlLabel
        control={<Checkbox size="small" defaultChecked />}
        label="Discharged"
        sx={{ '& .MuiTypography-root': { fontSize: '0.875rem' } }}
      />
      <FormControlLabel
        control={<Checkbox size="small" />}
        label="Died"
        sx={{ '& .MuiTypography-root': { fontSize: '0.875rem' } }}
      />
      <FormControlLabel
        control={<Checkbox size="small" />}
        label="Transferred Out"
        sx={{ '& .MuiTypography-root': { fontSize: '0.875rem' } }}
      />
    </Box>
  </Box>
</Stack>
              
            <Stack spacing={2}>
            {/* ✅ SERVICE PROVIDED - Updates First */}
                          
                  <FormControl fullWidth size="small" disabled={claimsData.patientState === 'Inpatient'}>
                  <InputLabel>Outpatient Service</InputLabel>
                  <Select
                    value={serviceProvided}
                    label="Outpatient Service"
                    onChange={async (e) => {
                      const newService = e.target.value;
                      const selectedServiceData = insuredServices.find(s => s.name === newService);
                      
                      setServiceProvided(newService);
                      handleInputChange('servicesProvided', newService);
                      
                      // ✅ UPDATE SPECIALTY FIELDS
                      if (selectedServiceData) {
                        const whichCode = selectedServiceData.code || '';
                        setClaimsData(prev => ({
                          ...prev,
                          servicesProvided: newService,
                          specialtyGDRG: whichCode,
                          specialtyDescription: newService,
                          specialtyCode: whichCode.substring(0, 4)
                        }));
                      }

                      // ✅ Auto-save if attendance type is selected
                      if (attendanceType && newService && selectedPatientData) {
                        const result = await saveServiceProvided(false, attendanceType, newService, selectedPatientData);
                        
                        // ✅ SHOW SUCCESS MESSAGE AND RELOAD
                        if (result) {
                          // Reload service and attendance data
                          loadServiceAndAttendance(selectedPatientData.patient_id, selectedPatientData.d_dat);
                        }
                      }
                    }}
                    sx={{ borderRadius: 2 }}
                  >
                    <MenuItem value="">Select Service Provided</MenuItem>
                    {insuredServices.length > 0 ? (
                      insuredServices.map((srv) => (
                        <MenuItem key={srv.id} value={srv.name}>
                          {srv.name}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem disabled>No services found for this insurance</MenuItem>
                    )}
                  </Select>
                </FormControl>

                 {/* ✅ ATTENDANCE TYPE - Auto-saves when changed */}
                <FormControl fullWidth size="small">
                  <InputLabel>Attendance Type</InputLabel>
                  <Select
                    value={attendanceType}
                    label="Attendance Type"
                    onChange={(e) => {
                      const newType = e.target.value;
                      setAttendanceType(newType);
                      handleInputChange('attendanceType', newType);

                      // ✅ Auto-save if service is selected
                      if (serviceProvided && newType && selectedPatientData) {
                        saveServiceProvided(false, newType, serviceProvided, selectedPatientData);
                      }
                    }}
                    sx={{ borderRadius: 2 }}
                  >
                    <MenuItem value="Attendance>>">Select Attendance</MenuItem>
                    <MenuItem value="Chronic Follow-up">Chronic Follow-up</MenuItem>
                    <MenuItem value="Emergency/Acute Episode">Emergency/Acute Episode</MenuItem>
                    <MenuItem value="Antenatal">Antenatal</MenuItem>
                    <MenuItem value="Postnatal">Postnatal</MenuItem>
                  </Select>
                </FormControl>

                {/* ✅ NEW SPECIALTY FIELDS */}
              
                  <TextField
                    fullWidth
                    size="small"
                    label="Specialty GDRG"
                    value={claimsData.specialtyGDRG || ''}
                    disabled
                    sx={{ 
                      '& .MuiOutlinedInput-root': { borderRadius: 2 },
                      '& .Mui-disabled': { 
                        backgroundColor: 'rgba(0, 0, 0, 0.02)',
                        WebkitTextFillColor: 'rgba(0, 0, 0, 0.6)'
                      }
                    }}
                  />

                  <TextField
                    fullWidth
                    size="small"
                    label="Specialty Description"
                    value={claimsData.specialtyDescription || ''}
                    disabled
                    sx={{ 
                      '& .MuiOutlinedInput-root': { borderRadius: 2 },
                      '& .Mui-disabled': { 
                        backgroundColor: 'rgba(0, 0, 0, 0.02)',
                        WebkitTextFillColor: 'rgba(0, 0, 0, 0.6)'
                      }
                    }}
                  />

                  <TextField
                    fullWidth
                    size="small"
                    label="Specialty Code"
                    value={claimsData.specialtyCode || ''}
                    disabled
                    sx={{ 
                      '& .MuiOutlinedInput-root': { borderRadius: 2 },
                      '& .Mui-disabled': { 
                        backgroundColor: 'rgba(0, 0, 0, 0.02)',
                        WebkitTextFillColor: 'rgba(0, 0, 0, 0.6)'
                      }
                    }}
                  />
                </Stack>

             
              </Box>


             <Box sx={{ 
                display: 'grid', 
                gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
                gap: 2, 
                mb: 3
              }}>
                <TextField
                  fullWidth
                  size="small"
                  label="Physician Name"
                  value={claimsData.physicianName}
                  onChange={(e) => handleInputChange('physicianName', e.target.value)}
                  InputProps={{
                    endAdornment: selectedPatientId && (
                      <InputAdornment position="end">
                        <IconButton
                          size="small"
                          onClick={() => {
                            // You can add save functionality here if needed
                            Swal.fire({
                              icon: "success",
                              title: "Updated",
                              text: "Physician Name updated!",
                              timer: 1500,
                              showConfirmButton: false,
                            });
                          }}
                          sx={{
                            color: '#1A9B7F',
                            '&:hover': { bgcolor: 'rgba(26, 155, 127, 0.08)' }
                          }}
                        >
                          <EditIcon sx={{ fontSize: 16 }} />
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                />

                <TextField
                  fullWidth
                  size="small"
                  label="Physician Code"
                  value={claimsData.physicianCode}
                  onChange={(e) => handleInputChange('physicianCode', e.target.value)}
                  InputProps={{
                    endAdornment: selectedPatientId && (
                      <InputAdornment position="end">
                        <IconButton
                          size="small"
                          onClick={() => {
                            // You can add save functionality here if needed
                            Swal.fire({
                              icon: "success",
                              title: "Updated",
                              text: "Physician Code updated!",
                              timer: 1500,
                              showConfirmButton: false,
                            });
                          }}
                          sx={{
                            color: '#1A9B7F',
                            '&:hover': { bgcolor: 'rgba(26, 155, 127, 0.08)' }
                          }}
                        >
                          <EditIcon sx={{ fontSize: 16 }} />
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                />
              </Box>

            
            </Paper>
          </Fade>

       
          <Fade in timeout={1200}>
            <Paper 
              elevation={0}
              sx={{
                p: 2.5,
                borderRadius: 2.5,
                border: '1px solid #e5e9ef',
                bgcolor: '#fff',
              }}
            >
              <SectionHeader number={3} title="Patient Care Services (clinical services)" icon={AssignmentIcon} />

             
               <Grid container spacing={3} alignItems="flex-start" columns={{ xs: 4, sm: 8, md: 12 }}>

             
              {/* Diagnosis(es) */}
              <Grid item xs={12} size={6}>
                <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 1 }}>
                  Diagnosis(es)
                </Typography>

                {loadingDiagnosisOptions ? (
                  <Box sx={{ 
                    p: 2, 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    border: '1px solid rgba(0,0,0,0.23)',
                    borderRadius: 1,
                    minHeight: 56
                  }}>
                    <CircularProgress size={24} sx={{ color: '#1A9B7F', mr: 1.5 }} />
                    <Typography variant="body2" color="text.secondary" fontWeight={600}>
                      Loading diagnosis options...
                    </Typography>
                  </Box>
                ) : (
                  <Autocomplete
                    multiple
                    options={diagnosisOptions}
                    value={selectedDiagnoses || []}
                    loading={loading}
                    disabled={loading}
                    onChange={(event, newValue) => {
                      setSelectedDiagnoses(newValue);
                      saveOrUpdateDiagnosis(newValue);
                    }}
                    getOptionLabel={(option) =>
                      option && option.code && option.name
                        ? `${option.name}`
                        : ""
                    }
                    filterSelectedOptions
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    filterOptions={(options, { inputValue }) => {
                      const search = inputValue.toLowerCase();
                      return options.filter(
                        (opt) =>
                          opt.name.toLowerCase().includes(search) ||
                          opt.code.toLowerCase().includes(search)
                      );
                    }}
                    renderInput={(params) => (
                      <TextField 
                        {...params} 
                        placeholder="Search by code or diagnosis name..." 
                        size="small"
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {loading && (
                                <Box sx={{ display: 'flex', alignItems: 'center', mr: 1 }}>
                                  <CircularProgress size={20} sx={{ color: '#1A9B7F' }} />
                                </Box>
                              )}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <li {...props} key={option.id}>
                      <Box>
                          <Typography variant="body2" fontWeight="bold">
                            {option.name}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            Code: {option.core} | ICD10: {option.code}  | Tariff: {option.tariff}
                          </Typography>
                        </Box>
                      </li>
                    )}
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => (
                        <Chip
                          key={option.id}
                          label={option.name}
                          {...getTagProps({ index })}
                          size="small"
                        />
                      ))
                    }
                  />
                )}
              </Grid>

              {/* Procedure(s) */}
              <Grid item xs={12} size={6}>
                <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 1 }}>
                  Procedure(s)
                </Typography>

                {loadingProcedureOptions ? (
                  <Box sx={{ 
                    p: 2, 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    border: '1px solid rgba(0,0,0,0.23)',
                    borderRadius: 1,
                    minHeight: 56
                  }}>
                    <CircularProgress size={24} sx={{ color: '#1A9B7F', mr: 1.5 }} />
                    <Typography variant="body2" color="text.secondary" fontWeight={600}>
                      Loading procedure options...
                    </Typography>
                  </Box>
                ) : (
                  <Autocomplete
                    multiple
                    options={procedureOptions}
                    value={selectedProcedures || []}
                    loading={loading}
                    disabled={loading}
                    onChange={(event, newValue) => {
                      setSelectedProcedures(newValue);
                      saveOrUpdateProcedure(newValue);
                    }}
                    getOptionLabel={(option) =>
                      option && option.name ? `${option.name}` : ""
                    }
                    filterSelectedOptions
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    filterOptions={(options, { inputValue }) => {
                      const search = inputValue.toLowerCase();
                      return options.filter((opt) =>
                        opt.name && opt.name.toLowerCase().includes(search)
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Search by procedure code or name..."
                        size="small"
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {loading && (
                                <Box sx={{ display: 'flex', alignItems: 'center', mr: 1 }}>
                                  <CircularProgress size={20} sx={{ color: '#1A9B7F' }} />
                                </Box>
                              )}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <li {...props} key={option.id}>
                        <Box>
                          <Typography variant="body2" fontWeight="bold">
                            {option.name}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            Code: {option.G_DRG} | Tariff: {option.tariff}
                          </Typography>
                        </Box>
                      </li>
                    )}
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => (
                        <Chip
                          key={option.id}
                          label={option.name}
                          {...getTagProps({ index })}
                          size="small"
                        />
                      ))
                    }
                  />
                )}
              </Grid>


              {/* Lab/Investigation */}
              <Grid item xs={12} size={6}>
                <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 1 }}>
                  Lab/Investigation
                </Typography>

                {loadingLabOptions ? (
                  <Box sx={{ 
                    p: 2, 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    border: '1px solid rgba(0,0,0,0.23)',
                    borderRadius: 1,
                    minHeight: 56
                  }}>
                    <CircularProgress size={24} sx={{ color: '#1A9B7F', mr: 1.5 }} />
                    <Typography variant="body2" color="text.secondary" fontWeight={600}>
                      Loading lab options...
                    </Typography>
                  </Box>
                ) : (
                  <Autocomplete
                    multiple
                    options={labOptions}
                    value={selectedLabs || []}
                    loading={loading}
                    disabled={loading}
                    onChange={(event, newValue) => {
                      setSelectedLabs(newValue);
                      saveOrUpdateLabs(newValue);
                    }}
                    getOptionLabel={(option) =>
                      option && option.name ? `${option.name}` : ""
                    }
                    filterSelectedOptions
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    filterOptions={(options, { inputValue }) => {
                      const search = inputValue.toLowerCase();
                      return options.filter((opt) =>
                        opt.name && opt.name.toLowerCase().includes(search)
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Search by lab name..."
                        size="small"
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {loading && (
                                <Box sx={{ display: 'flex', alignItems: 'center', mr: 1 }}>
                                  <CircularProgress size={20} sx={{ color: '#1A9B7F' }} />
                                </Box>
                              )}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <li {...props} key={option.id}>
                        <Box>
                          <Typography variant="body2" fontWeight="bold">
                            {option.name}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            Code: {option.code} | Tariff: {option.cost}
                          </Typography>
                        </Box>
                      </li>
                    )}
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => (
                        <Chip
                          key={option.id}
                          label={option.name}
                          {...getTagProps({ index })}
                          size="small"
                        />
                      ))
                    }
                  />
                )}
              </Grid>


              {/* Scan/Imaging */}
            <Grid item xs={12} size={6}>
              <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 1 }}>
                Scan/Imaging
              </Typography>

              {loadingScanOptions ? (
                <Box sx={{ 
                  p: 2, 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  border: '1px solid rgba(0,0,0,0.23)',
                  borderRadius: 1,
                  minHeight: 56
                }}>
                  <CircularProgress size={24} sx={{ color: '#1A9B7F', mr: 1.5 }} />
                  <Typography variant="body2" color="text.secondary" fontWeight={600}>
                    Loading scan options...
                  </Typography>
                </Box>
              ) : (
                <Autocomplete
                  multiple
                  options={scanOptions}
                  value={selectedScans || []}
                  loading={loading}
                  disabled={loading}
                  onChange={(event, newValue) => {
                    setSelectedScans(newValue);
                    saveOrUpdateScans(newValue);
                  }}
                  getOptionLabel={(option) =>
                    option && option.name ? `${option.name}` : ""
                  }
                  filterSelectedOptions
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                  filterOptions={(options, { inputValue }) => {
                    const search = inputValue.toLowerCase();
                    return options.filter((opt) =>
                      opt.name && opt.name.toLowerCase().includes(search)
                    );
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Search by scan name..."
                      size="small"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {loading && (
                              <Box sx={{ display: 'flex', alignItems: 'center', mr: 1 }}>
                                <CircularProgress size={20} sx={{ color: '#1A9B7F' }} />
                              </Box>
                            )}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                  renderOption={(props, option) => (
                    <li {...props} key={option.id}>
                      <Box>
                        <Typography variant="body2" fontWeight="bold">
                          {option.name}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          Code: {option.code} | Tariff: {option.cost}
                        </Typography>
                      </Box>
                    </li>
                  )}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        key={option.id}
                        label={option.name}
                        {...getTagProps({ index })}
                        size="small"
                      />
                    ))
                  }
                />
              )}
            </Grid>

              </Grid>

              {/* ✅ MEDICATION LIST BOX */}
<Fade in timeout={800}>
  <Paper
    elevation={0}
    sx={{
      p: 2.5,
      borderRadius: 2.5,
      border: '1px solid #e5e9ef',
      bgcolor: '#fff',
      mt: 2,
    }}
  >
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      mb: 2,
      pb: 1.25,
      borderBottom: '1px solid #eef2f6',
    }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
        <Box
          sx={{
            width: 26,
            height: 26,
            borderRadius: 1,
            bgcolor: '#1A9B7F',
            color: '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 800,
            fontSize: '0.82rem',
          }}
        >
          4
        </Box>
        <MedicationIcon sx={{ color: '#1A9B7F', fontSize: 20 }} />
        <Typography sx={{
          fontSize: '0.98rem',
          fontWeight: 700,
          color: '#0f172a',
          letterSpacing: '-0.15px',
        }}>
          Requested Medications
        </Typography>
      </Box>

      <Button
        variant="contained"
        size="small"
        startIcon={<MedicationIcon />}
        onClick={() => setMedDialogOpen(true)}
        disabled={!selectedPatientId}
        sx={{
          borderRadius: 2,
          textTransform: 'none',
          fontWeight: 600,
        background: '#1A9B7F',
          '&:hover': {
           background: '#1A9B7F',
          },
          '&:disabled': {
            background: 'rgba(0,0,0,0.12)',
            color: 'rgba(0,0,0,0.26)'
          }
        }}
      >
        Manage Medications
      </Button>
    </Box>

    {loadingMeds ? (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', py: 4 }}>
        <CircularProgress size={40} sx={{ color: '#1A9B7F' }} />
        <Typography variant="body2" color="text.secondary" fontWeight={600} sx={{ ml: 2 }}>
          Loading medications...
        </Typography>
      </Box>
    ) : !selectedPatientId ? (
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', py: 4 }}>
        <MedicationIcon sx={{ fontSize: 48, color: 'text.disabled', mb: 1 }} />
        <Typography variant="body2" color="text.secondary">
          Select a patient to view requested medications
        </Typography>
      </Box>
    ) : requestedMeds.length === 0 ? (
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', py: 4 }}>
        <MedicationIcon sx={{ fontSize: 48, color: 'text.disabled', mb: 1 }} />
        <Typography variant="body2" color="text.secondary">
          No medications requested for this patient
        </Typography>
      </Box>
    ) : (
      <>
        <TableContainer sx={{ 
          maxHeight: 400,
          border: '1px solid rgba(0,0,0,0.08)', 
          borderRadius: 2,
          boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
          bgcolor: 'white'
        }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell sx={{ bgcolor: '#f8f9fa', fontWeight: 700, fontSize: '0.8rem', color: '#0f172a', borderBottom: '2px solid  #1A9B7F' }}>Date</TableCell>
                <TableCell sx={{ bgcolor: '#f8f9fa', fontWeight: 700, fontSize: '0.8rem', color: '#0f172a', borderBottom: '2px solid  #1A9B7F' }}>Drug</TableCell>
                 <TableCell sx={{ bgcolor: '#f8f9fa', fontWeight: 700, fontSize: '0.8rem', color: '#0f172a', borderBottom: '2px solid  #1A9B7F' }}>Status</TableCell>
                <TableCell sx={{ bgcolor: '#f8f9fa', fontWeight: 700, fontSize: '0.8rem', color: '#0f172a', borderBottom: '2px solid  #1A9B7F' }}>Dose</TableCell>
                <TableCell sx={{ bgcolor: '#f8f9fa', fontWeight: 700, fontSize: '0.8rem', color: '#0f172a', borderBottom: '2px solid  #1A9B7F' }}>Freq</TableCell>
                 <TableCell sx={{ bgcolor: '#f8f9fa', fontWeight: 700, fontSize: '0.8rem', color: '#0f172a', borderBottom: '2px solid  #1A9B7F' }}>Route</TableCell>
                <TableCell sx={{ bgcolor: '#f8f9fa', fontWeight: 700, fontSize: '0.8rem', color: '#0f172a', borderBottom: '2px solid  #1A9B7F' }}>Days</TableCell>
                <TableCell sx={{ bgcolor: '#f8f9fa', fontWeight: 700, fontSize: '0.8rem', color: '#0f172a', borderBottom: '2px solid  #1A9B7F' }}>Qty</TableCell>
                <TableCell sx={{ bgcolor: '#f8f9fa', fontWeight: 700, fontSize: '0.8rem', color: '#0f172a', borderBottom: '2px solid   #1A9B7F' }}>unit Cost</TableCell>
                <TableCell sx={{ bgcolor: '#f8f9fa', fontWeight: 700, fontSize: '0.8rem', color: '#0f172a', borderBottom: '2px solid   #1A9B7F' }}>Total</TableCell>
                <TableCell sx={{ bgcolor: '#f8f9fa', fontWeight: 700, fontSize: '0.8rem', color: '#0f172a', borderBottom: '2px solid #1A9B7F', textAlign: 'center' }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {requestedMeds.map((med, index) => (
                <TableRow 
                  key={index}
                  sx={{ 
                    '&:nth-of-type(odd)': { bgcolor: 'rgba(0, 0, 0, 0.02)' },
                    '&:hover': { bgcolor: 'rgba(250, 112, 154, 0.08)' }
                  }}
                >
                  <TableCell>{med.date}</TableCell>
                  <TableCell>
                    <Box>
                      <Typography
                        variant="body2"
                        fontWeight={600}
                        sx={{ color: '#0f172a', lineHeight: 1.2 }}
                      >
                        {med.drug}
                      </Typography>

                      {med.code && (
                        <Typography
                          variant="caption"
                          sx={{
                            color: 'text.secondary',
                            fontStyle: 'italic',
                            display: 'block',
                            mt: 0.2
                          }}
                        >
                          Code: {med.code}
                        </Typography>
                      )}
                    </Box>
                  </TableCell>

                   <TableCell>{med.dug_status}</TableCell>
                  <TableCell>{med.dose}</TableCell>
                  <TableCell>{med.freq}</TableCell>
                   <TableCell>{med.route}</TableCell>
                  <TableCell>{med.days}</TableCell>
                  <TableCell>{med.qty}</TableCell>
                  <TableCell>{med.unit_cost}</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}> { (med.unit_cost *  med.qty) .toFixed(2)}</TableCell>
                  
                  
                    <TableCell sx={{ textAlign: 'center' }}>
                  <Tooltip title="Delete Medication">
                    <IconButton
                      size="small"
                      color="error"
                       onClick={() => handleDeleteMedication(med)}
                      sx={{
                        '&:hover': { 
                          bgcolor: 'rgba(211, 47, 47, 0.08)',
                          transform: 'scale(1.1)'
                        },
                        transition: 'all 0.2s'
                      }}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </TableCell>
                  
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        
      </>
    )}
  </Paper>
</Fade>
              
            </Paper>
          </Fade>
        </Stack>

           <Stack direction="row" spacing={1.5} flexWrap="wrap" useFlexGap sx={{ mb: 3 }}>
               
               
              
                
                <Button 
                  variant="contained" 
                  size="small" 
                  startIcon={<DescriptionIcon />}
                  sx={{ 
                    borderRadius: 2,
                    textTransform: 'none',
                    background: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)',
                    color: '#333',
                    '&:hover': {
                      background: 'linear-gradient(135deg, #fcb69f 0%, #ffecd2 100%)',
                    }
                  }}
                >
                  Documentation
                </Button>
              </Stack>
      </Box>

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert 
          onClose={handleCloseSnackbar} 
          severity={snackbar.severity}
          variant="filled"
          sx={{ 
            width: '100%',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            fontWeight: 600
          }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>



    {/* ✅ MEDICATION DIALOG */}
   
    <Dialog
      open={medDialogOpen}
      onClose={() => setMedDialogOpen(false)}
      maxWidth="lx"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          maxHeight: '90vh'
        }
      }}
    >
      <DialogTitle sx={{ 
        borderBottom: '2px solid #1A9B7F',
        pb: 2,
        background: 'rgba(26, 155, 127, 0.05)'
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: '10px',
                background: '#1A9B7F',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <MedicationIcon sx={{ color: 'white', fontSize: 24 }} />
            </Box>
            <Typography variant="h6" fontWeight={700} sx={{ color: '#0f172a' }}>
              Medication Management
            </Typography>
          </Box>
          <IconButton onClick={() => setMedDialogOpen(false)} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ p: 3, bgcolor: '#f8f9fa' }}>
        <Grid container spacing={3} columns={{ xs: 4, sm: 8, md: 12 }}>


          {/* ================= LEFT: AVAILABLE MEDICATIONS ================= */}
          <Grid item xs={12} md={5} size={5}>
            <Paper 
              elevation={0}
              sx={{ 
                p: 2.5, 
                borderRadius: 2,
                border: '1px solid rgba(0,0,0,0.08)',
                height: '100%'
              }}
            >
              <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 2, color: '#0f172a' }}>
                Available Medications
              </Typography>

              <TextField
                fullWidth
                size="small"
                placeholder="Search medication..."
                value={medSearchTerm}
                onChange={(e) => setMedSearchTerm(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon fontSize="small" sx={{ color: '#1A9B7F' }} />
                    </InputAdornment>
                  ),
                }}
                sx={{ 
                  mb: 2,
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                    bgcolor: 'white'
                  }
                }}
              />

              {loadingAvailableMeds ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                  <CircularProgress size={40} sx={{ color: '#1A9B7F' }} />
                </Box>
              ) : (
                <>
                  <TableContainer sx={{ 
                    maxHeight: 500,
                    border: '1px solid rgba(0,0,0,0.08)',
                    borderRadius: 2,
                    bgcolor: 'white'
                  }}>
                    <Table stickyHeader size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{ 
                            bgcolor: '#f8f9fa', 
                            fontWeight: 700, 
                            fontSize: '0.8rem',
                            borderBottom: '2px solid #1A9B7F'
                          }}>
                            Medication Name
                          </TableCell>
                          <TableCell 
                            align="center" 
                            sx={{ 
                              bgcolor: '#f8f9fa', 
                              fontWeight: 700, 
                              fontSize: '0.8rem',
                              borderBottom: '2px solid #1A9B7F',
                              width: 80
                            }}
                          >
                            Action
                          </TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {medications
                          .filter(m =>
                            m.name.toLowerCase().includes(medSearchTerm.toLowerCase())
                          )
                          .slice(
                            medPage * medRowsPerPage,
                            medPage * medRowsPerPage + medRowsPerPage
                          )
                          .map((med, idx) => (
                            <TableRow 
                              key={idx}
                              hover
                              sx={{
                                '&:nth-of-type(odd)': { bgcolor: 'rgba(0, 0, 0, 0.02)' },
                                '&:hover': { bgcolor: 'rgba(26, 155, 127, 0.08)' }
                              }}
                            >
                                <TableCell>
                                <Box>
                                  <Typography
                                    variant="body2"
                                    fontWeight={600}
                                    sx={{ color: '#0f172a', lineHeight: 1.2 }}
                                  >
                                    {med.name}
                                  </Typography>

                                  {med.code && (
                                    <Typography
                                      variant="caption"
                                      sx={{
                                        color: 'text.secondary',
                                        fontStyle: 'italic',
                                        display: 'block',
                                        mt: 0.2
                                      }}
                                    >
                                      Code: {med.code}
                                    </Typography>
                                  )}
                                </Box>
                              </TableCell>

                              <TableCell align="center">
                                <Tooltip title="Select Medication">
                                  <IconButton
                                    size="small"
                                     onClick={() => handleSelectMedication(med)}
                                    sx={{
                                      color: '#1A9B7F',
                                      '&:hover': {
                                        bgcolor: 'rgba(26, 155, 127, 0.15)',
                                        transform: 'scale(1.1)'
                                      },
                                      transition: 'all 0.2s'
                                    }}
                                  >
                                    <Send fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>

                  <TablePagination
                    component="div"
                    count={medications.filter(m =>
                      m.name.toLowerCase().includes(medSearchTerm.toLowerCase())
                    ).length}
                    page={medPage}
                    rowsPerPage={medRowsPerPage}
                    onPageChange={(e, p) => setMedPage(p)}
                    onRowsPerPageChange={(e) => {
                      setMedRowsPerPage(parseInt(e.target.value, 10));
                      setMedPage(0);
                    }}
                    rowsPerPageOptions={[5, 10, 25]}
                    sx={{
                      '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                        fontSize: '0.75rem',
                        fontWeight: 600
                      }
                    }}
                  />
                </>
              )}
            </Paper>
          </Grid>


          {/* ================= RIGHT: MEDICATION REQUEST FORM ================= */}
          <Grid item xs={12} md={7} size={7}>
            <Paper
    elevation={0}
    sx={{
      p: 3,
      borderRadius: 2,
      border: '1px solid rgba(0,0,0,0.08)',
      bgcolor: 'white'
    }}
  >
    {/* Header */}
    <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 2 }}>
      {editingIndex !== null ? 'Edit Medication Request' : 'New Medication Request'}
    </Typography>

    {/* Selected Medication */}
    {selectedMed && (
      <Alert severity="info" icon={<MedicationIcon />} sx={{ mb: 2 }}>
        <Typography variant="body2" fontWeight={600}>
          Selected: {selectedMed.name}
        </Typography>
      </Alert>
    )}

    <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
      {/* Selected Medication */}
      <Grid item xs={12} size={5}>
        <TextField
          label="Selected Medication"
          value={selectedMed?.name || ''}
          fullWidth
          disabled
          size="small"
          sx={{
            "& .MuiInputBase-input.Mui-disabled": { WebkitTextFillColor: "#000", opacity: 1 },
            "& .MuiInputLabel-root.Mui-disabled": { color: "#000", opacity: 1 }
          }}
        />
      </Grid>

      {/* Auto Calculate */}
      <Grid item xs={12} size={3}>
        <FormControlLabel
          control={
            <Checkbox
              checked={autoCalculate}
              onChange={(e) => setAutoCalculate(e.target.checked)}
            />
          }
          label="Auto Calculate Quantity"
        />
      </Grid>

      {/* Dose */}
      <Grid item xs={6} size={2}>
        <TextField
          label="Dose Amount"
          value={doseAmount}
          onChange={(e) => {
            setDoseAmount(e.target.value);
            if (e.target.value) setDoseAmountError(false);
          }}
          fullWidth
          size="small"
          error={doseAmountError}
          helperText={doseAmountError ? 'Required' : ''}
        />
      </Grid>

      <Grid item xs={6} size={2}>
        <TextField
          label="Dose Unit"
          placeholder="mg, ml, tab"
          value={doseUnit}
          onChange={(e) => setDoseUnit(e.target.value)}
          fullWidth
          size="small"
        />
      </Grid>

      {/* Frequency & Days */}
      <Grid item xs={6} size={5}>
        <FormControl fullWidth size="small" error={frequencyError}>
          <InputLabel>Frequency</InputLabel>
          <Select
            value={frequency}
            onChange={(e) => {
              setFrequency(e.target.value);
              if (e.target.value) setFrequencyError(false);
            }}
          >
            {standardFrequencies.map(freq => (
              <MenuItem key={freq} value={freq}>{freq}</MenuItem>
            ))}
          </Select>
          {frequencyError && <FormHelperText>Required</FormHelperText>}
        </FormControl>
      </Grid>

      <Grid item xs={6}size={2} >
        <TextField
          label="Days"
          type="number"
          value={days}
          onChange={(e) => {
            const val = Number(e.target.value);
            setDays(val);
            if (val > 0) setDaysError(false);
          }}
          fullWidth
          size="small"
          error={daysError}
          helperText={daysError ? 'Must be > 0' : ''}
        />
      </Grid>

      {/* Route & Quantity */}
      <Grid item xs={6} size={3}>
        <FormControl fullWidth size="small" error={routeError}>
          <InputLabel>Route</InputLabel>
          <Select
            value={route}
            onChange={(e) => {
              setRoute(e.target.value);
              if (e.target.value) setRouteError(false);
            }}
          >
            {MEDICATION_ROUTES.map(rt => (
              <MenuItem key={rt} value={rt}>{rt}</MenuItem>
            ))}
          </Select>
          {routeError && <FormHelperText>Required</FormHelperText>}
        </FormControl>
      </Grid>

      <Grid item xs={6} size={2}>
        <TextField
          label="Quantity"
          type="number"
          value={qty}
          onChange={(e) => !autoCalculate && setQty(Number(e.target.value))}
          fullWidth
          size="small"
          disabled={autoCalculate}
          sx={{
            "& .MuiInputBase-input.Mui-disabled": { WebkitTextFillColor: "#000", opacity: 1 },
            "& .MuiInputLabel-root.Mui-disabled": { color: "#000", opacity: 1 }
          }}
        />
      </Grid>


      <Grid item xs={12} size={4}>
      <FormControl fullWidth size="small" error={medicationDateError}>
        <InputLabel>Medication Date</InputLabel>
        <Select
          value={medicationDate}
          label="Medication Date"
          onChange={(e) => {
            setMedicationDate(e.target.value);
            setMedicationDateError(false);
          }}
        >
          <MenuItem value="ALL">All Dates</MenuItem>

          {medicationDates.map((d) => (
            <MenuItem key={d} value={d}>
              {d}
            </MenuItem>
          ))}
        </Select>

        {medicationDateError && (
          <FormHelperText>Required</FormHelperText>
        )}
      </FormControl>

    </Grid>



      {/* Actions */}
      <Grid item xs={12} size={6}>
        <Divider sx={{ my: 1 }} />
        <Stack direction="row" spacing={1.5}>
          {editingIndex !== null ? (
            <Button
              fullWidth
              variant="contained"
              startIcon={<Edit />}
              onClick={handleUpdateMedication}
            >
              Update Medication
            </Button>
          ) : (
            <Button
              fullWidth
              variant="contained"
              startIcon={<MedicationIcon />}
              onClick={handleAddMedication}
              disabled={!selectedMed}
            >
              Add to Request
            </Button>
          )}

          <Button
            fullWidth
            variant="outlined"
            startIcon={<CloseIcon />}
            onClick={handleClearMedication}
            color="error"
          >
            Clear
          </Button>
        </Stack>
      </Grid>
    </Grid>
  </Paper>

            {/* ================= REQUESTED MEDICATIONS LIST ================= */}
            <Paper 
              elevation={0}
              sx={{ 
                p: 2.5, 
                mt: 2,
                borderRadius: 2,
                border: '1px solid rgba(0,0,0,0.08)',
                bgcolor: 'white'
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                <Typography variant="subtitle1" fontWeight={700} sx={{ color: '#0f172a' }}>
                  Requested Medications
                </Typography>
                {requestedMeds.length > 0 && (
                  <Chip 
                    label={`${requestedMeds.length} item${requestedMeds.length !== 1 ? 's' : ''}`}
                    size="small"
                    sx={{ 
                      background: '#1A9B7F',
                      color: 'white',
                      fontWeight: 600
                    }}
                  />
                )}
              </Box>

              <TableContainer sx={{ 
                maxHeight: 300,
                border: '1px solid rgba(0,0,0,0.08)',
                borderRadius: 2
              }}>
                <Table stickyHeader size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ bgcolor: '#f8f9fa', fontWeight: 700, fontSize: '0.75rem', borderBottom: '2px solid #1A9B7F' }}>Date</TableCell>
                      <TableCell sx={{ bgcolor: '#f8f9fa', fontWeight: 700, fontSize: '0.75rem', borderBottom: '2px solid #1A9B7F' }}>Drug</TableCell>
                      <TableCell sx={{ bgcolor: '#f8f9fa', fontWeight: 700, fontSize: '0.75rem', borderBottom: '2px solid #1A9B7F' }}>Status</TableCell>
                      <TableCell sx={{ bgcolor: '#f8f9fa', fontWeight: 700, fontSize: '0.75rem', borderBottom: '2px solid #1A9B7F' }}>Dose</TableCell>
                      <TableCell sx={{ bgcolor: '#f8f9fa', fontWeight: 700, fontSize: '0.75rem', borderBottom: '2px solid #1A9B7F' }}>Freq</TableCell>
                      <TableCell sx={{ bgcolor: '#f8f9fa', fontWeight: 700, fontSize: '0.75rem', borderBottom: '2px solid #1A9B7F' }}>Days</TableCell>
                      <TableCell sx={{ bgcolor: '#f8f9fa', fontWeight: 700, fontSize: '0.75rem', borderBottom: '2px solid #1A9B7F' }}>Qty</TableCell>
                      <TableCell sx={{ bgcolor: '#f8f9fa', fontWeight: 700, fontSize: '0.75rem', borderBottom: '2px solid #1A9B7F' }}>Route</TableCell>
                      <TableCell sx={{ bgcolor: '#f8f9fa', fontWeight: 700, fontSize: '0.75rem', borderBottom: '2px solid #1A9B7F', textAlign: 'center' }}>Actions</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {requestedMeds.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={7}>
                          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 4 }}>
                            <MedicationIcon sx={{ fontSize: 48, color: 'text.disabled', mb: 1 }} />
                            <Typography variant="body2" color="text.secondary">
                              No medications requested yet
                            </Typography>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ) : (
                      filteredRequestedMeds
                        .slice(
                          reqMedPage * reqMedRowsPerPage,
                          reqMedPage * reqMedRowsPerPage + reqMedRowsPerPage
                        )
                        .map((r, idx) => (
                          <TableRow 
                            key={idx}
                            sx={{
                              '&:nth-of-type(odd)': { bgcolor: 'rgba(0, 0, 0, 0.02)' },
                              '&:hover': { bgcolor: 'rgba(26, 155, 127, 0.08)' }
                            }}
                          >

                             <TableCell>
                              <Chip 
                                label={r.date}
                                size="small"
                                sx={{ 
                                  borderColor: '#1A9B7F',
                                  color: '#1A9B7F',
                                  fontWeight: 500,
                                  fontSize: '0.7rem'
                                }}
                                variant="outlined"
                              />
                            </TableCell>
                            <TableCell>
                              <Box>
                                <Typography
                                  variant="body2"
                                  fontWeight={600}
                                  sx={{ color: '#0f172a', lineHeight: 1.2 }}
                                >
                                  {r.drug}
                                </Typography>

                                {r.code && (
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      color: 'text.secondary',
                                      fontStyle: 'italic',
                                      display: 'block',
                                      mt: 0.2
                                    }}
                                  >
                                    Code: {r.code}
                                  </Typography>
                                )}
                              </Box>
                            </TableCell>

                            <TableCell>{r.dug_status}</TableCell>
                            <TableCell>{r.dose}</TableCell>
                            <TableCell>{r.freq}</TableCell>
                            <TableCell>{r.days}</TableCell>
                            <TableCell>{r.qty}</TableCell>
                            <TableCell>{r.route}</TableCell>
                            <TableCell sx={{ textAlign: 'center' }}>
                              <Stack direction="row" spacing={0.5} justifyContent="center">
                                <Tooltip title="Edit">
                                  <IconButton
                                    size="small"
                                    onClick={() => handleEditMedication(idx)}
                                    sx={{
                                      color: '#1A9B7F',
                                      '&:hover': {
                                        bgcolor: 'rgba(26, 155, 127, 0.15)',
                                        transform: 'scale(1.1)'
                                      },
                                      transition: 'all 0.2s'
                                    }}
                                  >
                                    <Edit fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Delete">
                                  <IconButton
                                    size="small"
                                    onClick={() => handleDeleteMedication(r)}
                                    sx={{
                                      color: '#d32f2f',
                                      '&:hover': {
                                        bgcolor: 'rgba(211, 47, 47, 0.15)',
                                        transform: 'scale(1.1)'
                                      },
                                      transition: 'all 0.2s'
                                    }}
                                  >
                                    <Delete fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              </Stack>
                            </TableCell>
                          </TableRow>
                        ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              {requestedMeds.length > 0 && (
                <TablePagination
                  component="div"
                  count={requestedMeds.length}
                  page={reqMedPage}
                  rowsPerPage={reqMedRowsPerPage}
                  onPageChange={(e, p) => setReqMedPage(p)}
                  onRowsPerPageChange={(e) => {
                    setReqMedRowsPerPage(parseInt(e.target.value, 10));
                    setReqMedPage(0);
                  }}
                  rowsPerPageOptions={[5, 10, 25]}
                  sx={{
                    '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                      fontSize: '0.75rem',
                      fontWeight: 600
                    }
                  }}
                />
              )}
            </Paper>
          </Grid>


        </Grid>
      </DialogContent>

      <DialogActions sx={{ 
        px: 3, 
        py: 2, 
        borderTop: '1px solid rgba(0,0,0,0.12)',
        bgcolor: '#f8f9fa'
      }}>
        <Button
          onClick={() => setMedDialogOpen(false)}
          variant="outlined"
          sx={{
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 600,
            borderColor: '#1A9B7F',
            color: '#1A9B7F',
            '&:hover': {
              borderColor: '#127a63',
              bgcolor: 'rgba(26, 155, 127, 0.08)'
            }
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>

    </Box>
  );
};

export default HospitalClaims;